import React, { Component, Fragment, useReducer, useState } from 'react'
import Box from '@mui/material/Box';

import './App.scss'
import logosquare from './img/logosquare.png'
import createdBy from './img/createdBy.png'
import backedBy from './img/backedBy.png'
import phone from './img/Home.png'
import Select from 'react-select';
import { TextField } from '@material-ui/core'; import DatePicker from '@mui/lab/DatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import formSubmitUrl from './config/urls'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import CustomPhoneNumber from './components/CustomPhoneInput/PhoneNumber'
import { parseISO } from 'date-fns'; 
import { formatDate } from './dateFormatUtil';

const axios = require('axios');
const airportOptions = [
  {
    "label": "AGR | Agra | Agra Airport | Uttar Pradesh | India",
    "value": "AGR | Agra | Agra Airport | Uttar Pradesh | India"
  },
  {
    "label": "AMD | Ahmedabad | Sardar Vallabhbhai Patel International Airport | Gujarat | India",
    "value": "AMD | Ahmedabad | Sardar Vallabhbhai Patel International Airport | Gujarat | India"
  },
  {
    "label": "AJL | Aizawl | Lengpui Airport | Mizoram | India",
    "value": "AJL | Aizawl | Lengpui Airport | Mizoram | India"
  },
  {
    "label": "IXD | Allahabad | Allahabad Airport | Uttar-Pradesh | India",
    "value": "IXD | Allahabad | Allahabad Airport | Uttar-Pradesh | India"
  },
  {
    "label": "ATQ | Amritsar | Sri Guru Ram Dass Jee International Airport Amritsar | Punjab | India",
    "value": "ATQ | Amritsar | Sri Guru Ram Dass Jee International Airport Amritsar | Punjab | India"
  },
  {
    "label": "IXU | Aurangabad | Aurangabad Airport | Maharashtra | India",
    "value": "IXU | Aurangabad | Aurangabad Airport | Maharashtra | India"
  },
  {
    "label": "RGH | Balurghat | Balurghat Airport | West-Bengal | India",
    "value": "RGH | Balurghat | Balurghat Airport | West-Bengal | India"
  },
  {
    "label": "BLR | Bangalore | Bengaluru International Airport | Karnataka | India",
    "value": "BLR | Bangalore | Bengaluru International Airport | Karnataka | India"
  },
  {
    "label": "BEP | Bellary | Bellary Airport | Karnataka | India",
    "value": "BEP | Bellary | Bellary Airport | Karnataka | India"
  },
  {
    "label": "BHU | Bhavnagar | Bhavnagar Airport | Gujarat | India",
    "value": "BHU | Bhavnagar | Bhavnagar Airport | Gujarat | India"
  },
  {
    "label": "BHO | Bhopal | Bhopal Airport | Madhya-Pradesh | India",
    "value": "BHO | Bhopal | Bhopal Airport | Madhya-Pradesh | India"
  },
  {
    "label": "BBI | Bhubaneswar | Biju Patnaik Airport | Odisha | India",
    "value": "BBI | Bhubaneswar | Biju Patnaik Airport | Odisha | India"
  },
  {
    "label": "BHJ | Bhuj | Bhuj Airport | Gujarat | India",
    "value": "BHJ | Bhuj | Bhuj Airport | Gujarat | India"
  },
  {
    "label": "BKB | Bikaner | Nal Airport | Rajasthan | India",
    "value": "BKB | Bikaner | Nal Airport | Rajasthan | India"
  },
  {
    "label": "CCJ | Calicut | Calicut International Airport | Kerala | India",
    "value": "CCJ | Calicut | Calicut International Airport | Kerala | India"
  },
  {
    "label": "IXC | Chandigarh | Chandigarh Airport | Chandigarh | India",
    "value": "IXC | Chandigarh | Chandigarh Airport | Chandigarh | India"
  },
  {
    "label": "MAA | Chennai | Chennai International Airport | Tamil-Nadu | India",
    "value": "MAA | Chennai | Chennai International Airport | Tamil-Nadu | India"
  },
  {
    "label": "COK | Cochin | Cochin International Airport | Kerala | India",
    "value": "COK | Cochin | Cochin International Airport | Kerala | India"
  },
  {
    "label": "CJB | Coimbatore | Coimbatore International Airport | Tamil-Nadu | India",
    "value": "CJB | Coimbatore | Coimbatore International Airport | Tamil-Nadu | India"
  },
  {
    "label": "GOI | Dabolim | Dabolim Airport | Dabolim | India",
    "value": "GOI | Dabolim | Dabolim Airport | Dabolim | India"
  },
  {
    "label": "DED | Dehradun | Dehradun Airport | Uttar-Pradesh | India",
    "value": "DED | Dehradun | Dehradun Airport | Uttar-Pradesh | India"
  },
  {
    "label": "DBR | Darbhanga | Darbhanga Airport | Bihar | India",
    "value": "DBR | Darbhanga | Darbhanga Airport | Bihar | India"
  },
  {
    "label": "DIB | Dibrugarh | Dibrugarh Airport | Assam | India",
    "value": "DIB | Dibrugarh | Dibrugarh Airport | Assam | India"
  },
  {
    "label": "DMU | Dimapur | Dimapur Airport | Nagaland | India",
    "value": "DMU | Dimapur | Dimapur Airport | Nagaland | India"
  },
  {
    "label": "DIU | Diu | Diu Airport | Gujarat | India",
    "value": "DIU | Diu | Diu Airport | Gujarat | India"
  },
  {
    "label": "GOP | Gorakhpur | Gorakhpur Airport | Uttar-Pradesh | India",
    "value": "GOP | Gorakhpur | Gorakhpur Airport | Uttar-Pradesh | India"
  },
  {
    "label": "GAU | Guwahati | Lokpriya Gopinath Bordoloi International Airport | Assam | India",
    "value": "GAU | Guwahati | Lokpriya Gopinath Bordoloi International Airport | Assam | India"
  },
  {
    "label": "GWL | Gwalior | Gwalior Airport | Madhya-Pradesh | India",
    "value": "GWL | Gwalior | Gwalior Airport | Madhya-Pradesh | India"
  },
  {
    "label": "HBX | Hubli | Hubli Airport | Karnataka | India",
    "value": "HBX | Hubli | Hubli Airport | Karnataka | India"
  },
  {
    "label": "BPM | Hyderabad | Begumpet Airport | Telangana | India",
    "value": "BPM | Hyderabad | Begumpet Airport | Telangana | India"
  },
  {
    "label": "HYD | Hyderabad | Rajiv Gandhi International Airport Shamshabad | Telangana | India",
    "value": "HYD | Hyderabad | Rajiv Gandhi International Airport Shamshabad | Telangana | India"
  },
  {
    "label": "IMF | Imphal | Imphal Airport | Manipur | India",
    "value": "IMF | Imphal | Imphal Airport | Manipur | India"
  },
  {
    "label": "IDR | Indore | Devi Ahilyabai Holkar Airport | Madhya-Pradesh | India",
    "value": "IDR | Indore | Devi Ahilyabai Holkar Airport | Madhya-Pradesh | India"
  },
  {
    "label": "JAI | Jaipur | Jaipur International Airport | Rajasthan | India",
    "value": "JAI | Jaipur | Jaipur International Airport | Rajasthan | India"
  },
  {
    "label": "IXA | Agartala | Maharaja Bir Bikram Airport | Tripura | India",
    "value": "IXA | Agartala | Maharaja Bir Bikram Airport | Tripura | India"
  },
  {
    "label": "IXJ | Jammu | Jammu Airport | Jammu-and-Kashmir | India",
    "value": "IXJ | Jammu | Jammu Airport | Jammu-and-Kashmir | India"
  },
  {
    "label": "JGA | Jamnagar | Jamnagar Airport | Gujarat | India",
    "value": "JGA | Jamnagar | Jamnagar Airport | Gujarat | India"
  },
  {
    "label": "PYB | Jeypore | Jeypore Airport | Odisha | India",
    "value": "PYB | Jeypore | Jeypore Airport | Odisha | India"
  },
  {
    "label": "JDH | Jodhpur | Jodhpur Airport | Rajasthan | India",
    "value": "JDH | Jodhpur | Jodhpur Airport | Rajasthan | India"
  },
  {
    "label": "JRH | Jorhat | Jorhat Airport | Assam | India",
    "value": "JRH | Jorhat | Jorhat Airport | Assam | India"
  },
  {
    "label": "IXY | Kandla | Kandla Airport | Gujarat | India",
    "value": "IXY | Kandla | Kandla Airport | Gujarat | India"
  },
  {
    "label": "HJR | Khajuraho | Khajuraho Airport | Madhya-Pradesh | India",
    "value": "HJR | Khajuraho | Khajuraho Airport | Madhya-Pradesh | India"
  },
  {
    "label": "IXN | Khowai | Khowai Airport | Tripura | India",
    "value": "IXN | Khowai | Khowai Airport | Tripura | India"
  },
  {
    "label": "KQH | Kishangarh | Kishangarh Airport Ajmer | Rajasthan | India",
    "value": "KQH | Kishangarh | Kishangarh Airport Ajmer | Rajasthan | India"
  },
  {
    "label": "CCU | Kolkata | Netaji Subhash Chandra Bose International Airport | West-Bengal | India",
    "value": "CCU | Kolkata | Netaji Subhash Chandra Bose International Airport | West-Bengal | India"
  },
  {
    "label": "LTU | Latur | Murod Kond Airport | Maharashtra | India",
    "value": "LTU | Latur | Murod Kond Airport | Maharashtra | India"
  },
  {
    "label": "IXL | Leh | Leh Kushok Bakula Rimpochee Airport | Jammu-and-Kashmir | India",
    "value": "IXL | Leh | Leh Kushok Bakula Rimpochee Airport | Jammu-and-Kashmir | India"
  },
  {
    "label": "IXI | Lilabari | North Lakhimpur Airport | Assam | India",
    "value": "IXI | Lilabari | North Lakhimpur Airport | Assam | India"
  },
  {
    "label": "KNU | Kanpur | Kanpur Airport | Uttar-Pradesh | India",
    "label": "KNU | Kanpur | Kanpur Airport | Uttar-Pradesh | India"
  },
  {
    "label": "LKO | Lucknow | Chaudhary Charan Singh International Airport | Uttar-Pradesh | India",
    "value": "LKO | Lucknow | Chaudhary Charan Singh International Airport | Uttar-Pradesh | India"
  },
  {
    "label": "IXM | Madurai | Madurai Airport | Tamil-Nadu | India",
    "value": "IXM | Madurai | Madurai Airport | Tamil-Nadu | India"
  },
  {
    "label": "LDA | Malda | Malda Airport | India",
    "value": "LDA | Malda | Malda Airport | India"
  },
  {
    "label": "IXE | Mangalore | Mangalore International Airport | Karnataka | India",
    "value": "IXE | Mangalore | Mangalore International Airport | Karnataka | India"
  },
  {
    "label": "BOM | Mumbai | Chhatrapati Shivaji International Airport | Maharashtra | India",
    "value": "BOM | Mumbai | Chhatrapati Shivaji International Airport | Maharashtra | India"
  },
  {
    "label": "MYQ | Mysore | Mysore Airport | Karnataka | India",
    "value": "MYQ | Mysore | Mysore Airport | Karnataka | India"
  },
  {
    "label": "NDC | Nanded | Nanded Airport | Maharashtra | India",
    "value": "NDC | Nanded | Nanded Airport | Maharashtra | India"
  },
  {
    "label": "NAG | Naqpur | Dr. Babasaheb Ambedkar International Airport | Maharashtra | India",
    "value": "NAG | Naqpur | Dr. Babasaheb Ambedkar International Airport | Maharashtra | India"
  },
  {
    "label": "ISK | Nashik | Gandhinagar Airport | Maharashtra | India",
    "value": "ISK | Nashik | Gandhinagar Airport | Maharashtra | India"
  },
  {
    "label": "DEL | New Delhi | Indira Gandhi International Airport | NCT | India",
    "value": "DEL | New Delhi | Indira Gandhi International Airport | NCT | India"
  },
  {
    "label": "PGH | Pantnagar | Pantnagar Airport | Uttar-Pradesh | India",
    "value": "PGH | Pantnagar | Pantnagar Airport | Uttar-Pradesh | India"
  },
  {
    "label": "IXT | Pasighat | Pasighat Airport | Arunachal-Pradesh | India",
    "value": "IXT | Pasighat | Pasighat Airport | Arunachal-Pradesh | India"
  },
  {
    "label": "PAT | Patna | Lok Nayak Jayaprakash Airport | Bihar | India",
    "value": "PAT | Patna | Lok Nayak Jayaprakash Airport | Bihar | India"
  },
  {
    "label": "PBD | Porbandar | Porbandar Airport | Gujarat | India",
    "value": "PBD | Porbandar | Porbandar Airport | Gujarat | India"
  },
  {
    "label": "IXZ | Port Blair | Vir Savarkar International Airport | Andaman-and-Nicobar | India",
    "value": "IXZ | Port Blair | Vir Savarkar International Airport | Andaman-and-Nicobar | India"
  },
  {
    "label": "PNQ | Pune | Pune Airport | Maharashtra | India",
    "value": "PNQ | Pune | Pune Airport | Maharashtra | India"
  },
  {
    "label": "RPR | Raipur | Raipur Airport | Madhya-Pradesh | India",
    "value": "RPR | Raipur | Raipur Airport | Madhya-Pradesh | India"
  },
  {
    "label": "RJA | Rajahmundry | Rajahmundry Airport | Andhra-Pradesh | India",
    "value": "RJA | Rajahmundry | Rajahmundry Airport | Andhra-Pradesh | India"
  },
  {
    "label": "RAJ | Rajkot | Rajkot Airport | Gujarat | India",
    "value": "RAJ | Rajkot | Rajkot Airport | Gujarat | India"
  },
  {
    "label": "IXR | Ranchi | Birsa Munda Airport | Jharkhand | India",
    "value": "IXR | Ranchi | Birsa Munda Airport | Jharkhand | India"
  },
  {
    "label": "SHL | Shillong | Shillong Airport | Meghalaya | India",
    "value": "SHL | Shillong | Shillong Airport | Meghalaya | India"
  },
  {
    "label": "IXS | Silchar | Silchar Airport | Assam | India",
    "value": "IXS | Silchar | Silchar Airport | Assam | India"
  },
  {
    "label": "IXB | Siliguri | Bagdogra Airport | West-Bengal | India",
    "value": "IXB | Siliguri | Bagdogra Airport | West-Bengal | India"
  },
  {
    "label": "SSE | Solapur | Solapur Airport | Maharashtra | India",
    "value": "SSE | Solapur | Solapur Airport | Maharashtra | India"
  },
  {
    "label": "SXR | Srinagar | Sheikh ul Alam Airport | Jammu-and-Kashmir | India",
    "value": "SXR | Srinagar | Sheikh ul Alam Airport | Jammu-and-Kashmir | India"
  },
  {
    "label": "STV | Surat | Surat International Airport | Gujarat | India",
    "value": "STV | Surat | Surat International Airport | Gujarat | India"
  },
  {
    "label": "TEI | Tezu | Tezu Airport | Arunachal-Pradesh | India",
    "value": "TEI | Tezu | Tezu Airport | Arunachal-Pradesh | India"
  },
  {
    "label": "TJV | Thanjavur | Tanjore Air Force Base | Tamil-Nadu | India",
    "value": "TJV | Thanjavur | Tanjore Air Force Base | Tamil-Nadu | India"
  },
  {
    "label": "TRZ | Tiruchirappally | Tiruchirapally Civil Airport Airport | Tamil-Nadu | India",
    "value": "TRZ | Tiruchirappally | Tiruchirapally Civil Airport Airport | Tamil-Nadu | India"
  },
  {
    "label": "TIR | Tirupati | Tirupati Airport | Andhra-Pradesh | India",
    "value": "TIR | Tirupati | Tirupati Airport | Andhra-Pradesh | India"
  },
  {
    "label": "TRV | Trivandrum | Trivandrum International Airport | Kerala | India",
    "value": "TRV | Trivandrum | Trivandrum International Airport | Kerala | India"
  },
  {
    "label": "UDR | Udaipur | Maharana Pratap Airport | Rajasthan | India",
    "value": "UDR | Udaipur | Maharana Pratap Airport | Rajasthan | India"
  },
  {
    "label": "BDQ | Vadodara | Vadodara Airport | Gujarat | India",
    "value": "BDQ | Vadodara | Vadodara Airport | Gujarat | India"
  },
  {
    "label": "VNS | Varanasi | Lal Bahadur Shastri Airport | Uttar Pradesh | India",
    "value": "VNS | Varanasi | Lal Bahadur Shastri Airport | Uttar Pradesh | India"
  },
  {
    "label": "VNS | Varanasi | Lal Bahadur Shastri Airport | Uttar-Pradesh | India",
    "value": "VNS | Varanasi | Lal Bahadur Shastri Airport | Uttar-Pradesh | India"
  },
  {
    "label": "GOI | Vasco da Gama | Dabolim Airport | Goa | India",
    "value": "GOI | Vasco da Gama | Dabolim Airport | Goa | India"
  },
  {
    "label": "VTZ | Visakhapatnam | Vishakhapatnam Airport | Andhra-Pradesh | India",
    "value": "VTZ | Visakhapatnam | Vishakhapatnam Airport | Andhra-Pradesh | India"
  },
  {
    "label": "WGC | Warrangal | Warangal Airport | Telangana | India",
    "value": "WGC | Warrangal | Warangal Airport | Telangana | India"
  },
  {
    "label": "EBL | Arbil | Erbil International Airport | Arbil | Iraq",
    "value": "EBL | Arbil | Erbil International Airport | Arbil | Iraq"
  },
  {
    "label": "BGW | Baghdad | Baghdad International Airport | Baghdad | Iraq",
    "value": "BGW | Baghdad | Baghdad International Airport | Baghdad | Iraq"
  },
  {
    "label": "BSR | Basrah | Basrah International Airport | Basra | Iraq",
    "value": "BSR | Basrah | Basrah International Airport | Basra | Iraq"
  },
  {
    "label": "OSB | Mosul | Mosul International Airport | Ninawa | Iraq",
    "value": "OSB | Mosul | Mosul International Airport | Ninawa | Iraq"
  },
  {
    "label": "NJF | Najaf | Al Najaf International Airport | Najaf Governorate | Iraq",
    "value": "NJF | Najaf | Al Najaf International Airport | Najaf Governorate | Iraq"
  },
  {
    "label": "ISU | Sulaymaniyah | Sulaymaniyah International Airport | As-Sulaymaniyah | Iraq",
    "value": "ISU | Sulaymaniyah | Sulaymaniyah International Airport | As-Sulaymaniyah | Iraq"
  },
  {
    "label": "YEH | Asalouyeh | Persian Gulf International Airport | Bushehr | Iran | Islamic Republic of",
    "value": "YEH | Asalouyeh | Persian Gulf International Airport | Bushehr | Iran | Islamic Republic of"
  },
  {
    "label": "BND | Bandar Abbas | Bandar Abbas International Airport | Hormozgan | Iran | Islamic Republic of",
    "value": "BND | Bandar Abbas | Bandar Abbas International Airport | Hormozgan | Iran | Islamic Republic of"
  },
  {
    "label": "IFN | Isfahan | Esfahan Shahid Beheshti International Airport | Isfahan | Iran | Islamic Republic of",
    "value": "IFN | Isfahan | Esfahan Shahid Beheshti International Airport | Isfahan | Iran | Islamic Republic of"
  },
  {
    "label": "MHD | Mashhad | Mashhad International Airport | Razavi-Khorasan | Iran | Islamic Republic of",
    "value": "MHD | Mashhad | Mashhad International Airport | Razavi-Khorasan | Iran | Islamic Republic of"
  },
  {
    "label": "SYZ | Shiraz | Shiraz Shahid Dastghaib International Airport | Fars | Iran | Islamic Republic of",
    "value": "SYZ | Shiraz | Shiraz Shahid Dastghaib International Airport | Fars | Iran | Islamic Republic of"
  },
  {
    "label": "IKA | Tehran | Imam Khomeini International Airport | Tehran | Iran | Islamic Republic of",
    "value": "IKA | Tehran | Imam Khomeini International Airport | Tehran | Iran | Islamic Republic of"
  },
  {
    "label": "THR | Tehran | Mehrabad International Airport | Tehran | Iran | Islamic Republic of",
    "value": "THR | Tehran | Mehrabad International Airport | Tehran | Iran | Islamic Republic of"
  },
  {
    "label": "ZAH | Zahedan | Zahedan International Airport | Sistan-and-Baluchestan | Iran | Islamic Republic of",
    "value": "ZAH | Zahedan | Zahedan International Airport | Sistan-and-Baluchestan | Iran | Islamic Republic of"
  },
  {
    "label": "KEF | Reykjavik | Keflavik International Airport | Southern Peninsula | Iceland",
    "value": "KEF | Reykjavik | Keflavik International Airport | Southern Peninsula | Iceland"
  },
  {
    "label": "ALL | Albenga | Villanova D'Albenga International Airport | Liguria | Italy",
    "value": "ALL | Albenga | Villanova D'Albenga International Airport | Liguria | Italy"
  },
  {
    "label": "BRI | Bari | Bari / Palese International Airport | Apulia | Italy",
    "value": "BRI | Bari | Bari / Palese International Airport | Apulia | Italy"
  },
  {
    "label": "MXP | Milan | Malpensa International Airport | Lombardy | Italy",
    "value": "MXP | Milan | Malpensa International Airport | Lombardy | Italy"
  },
  {
    "label": "NAP | Napoli | Napoli / Capodichino International Airport | Campania | Italy",
    "value": "NAP | Napoli | Napoli / Capodichino International Airport | Campania | Italy"
  },
  {
    "label": "PSA | Pisa | Pisa / San Giusto - Galileo Galilei International Airport | Tuscany | Italy",
    "value": "PSA | Pisa | Pisa / San Giusto - Galileo Galilei International Airport | Tuscany | Italy"
  },
  {
    "label": "RMI | Rimini | Rimini / Miramare - Federico Fellini International Airport | Emilia-Romagna | Italy",
    "value": "RMI | Rimini | Rimini / Miramare - Federico Fellini International Airport | Emilia-Romagna | Italy"
  },
  {
    "label": "FCO | Rome | Leonardo Da Vinci (Fiumicino) International Airport | Latium | Italy",
    "value": "FCO | Rome | Leonardo Da Vinci (Fiumicino) International Airport | Latium | Italy"
  },
  {
    "label": "TRN | Torino | Torino / Caselle International Airport | Piedmont | Italy",
    "value": "TRN | Torino | Torino / Caselle International Airport | Piedmont | Italy"
  },
  {
    "label": "KIN | Kingston | Norman Manley International Airport | Kingston | Jamaica",
    "value": "KIN | Kingston | Norman Manley International Airport | Kingston | Jamaica"
  },
  {
    "label": "MBJ | Montego Bay | Sangster International Airport | St-James | Jamaica",
    "value": "MBJ | Montego Bay | Sangster International Airport | St-James | Jamaica"
  },
  {
    "label": "ADJ | Amman | Amman-Marka International Airport | Amman | Jordan",
    "value": "ADJ | Amman | Amman-Marka International Airport | Amman | Jordan"
  },
  {
    "label": "AMM | Amman | Queen Alia International Airport | Amman | Jordan",
    "value": "AMM | Amman | Queen Alia International Airport | Amman | Jordan"
  },
  {
    "label": "AQJ | Aqaba | Aqaba King Hussein International Airport | Aqaba | Jordan",
    "value": "AQJ | Aqaba | Aqaba King Hussein International Airport | Aqaba | Jordan"
  },
  {
    "label": "KIX | Osaka | Kansai International Airport | Osaka | Japan",
    "value": "KIX | Osaka | Kansai International Airport | Osaka | Japan"
  },
  {
    "label": "ITM | Osaka | Osaka International Airport | Hyogo | Japan",
    "value": "ITM | Osaka | Osaka International Airport | Hyogo | Japan"
  },
  {
    "label": "NGO | Tokoname | Chubu Centrair International Airport | Aichi | Japan",
    "value": "NGO | Tokoname | Chubu Centrair International Airport | Aichi | Japan"
  },
  {
    "label": "NRT | Tokyo | Narita International Airport | Chiba | Japan",
    "value": "NRT | Tokyo | Narita International Airport | Chiba | Japan"
  },
  {
    "label": "HND | Tokyo | Tokyo International Airport | Tokyo | Japan",
    "value": "HND | Tokyo | Tokyo International Airport | Tokyo | Japan"
  },
  {
    "label": "EDL | Eldoret | Eldoret International Airport | Uasin-Gishu | Kenya",
    "value": "EDL | Eldoret | Eldoret International Airport | Uasin-Gishu | Kenya"
  },
  {
    "label": "MBA | Mombasa | Mombasa Moi International Airport | Mombasa | Kenya",
    "value": "MBA | Mombasa | Mombasa Moi International Airport | Mombasa | Kenya"
  },
  {
    "label": "NBO | Nairobi | Jomo Kenyatta International Airport | Nairobi-Area | Kenya",
    "value": "NBO | Nairobi | Jomo Kenyatta International Airport | Nairobi-Area | Kenya"
  },
  {
    "label": "FRU | Bishkek | Manas International Airport | Chuey | Kyrgyzstan",
    "value": "FRU | Bishkek | Manas International Airport | Chuey | Kyrgyzstan"
  },
  {
    "label": "PNH | Phnom Penh | Phnom Penh International Airport | Cambodia",
    "value": "PNH | Phnom Penh | Phnom Penh International Airport | Cambodia"
  },
  {
    "label": "REP | Siem Reap | Angkor International Airport | Siem-Reap | Cambodia",
    "value": "REP | Siem Reap | Angkor International Airport | Siem-Reap | Cambodia"
  },
  {
    "label": "KOS | Sihanukville | Sihanoukville International Airport | Kampot | Cambodia",
    "value": "KOS | Sihanukville | Sihanoukville International Airport | Kampot | Cambodia"
  },
  {
    "label": "CXI | Banana | Cassidy International Airport | Line-Islands | Kiribati",
    "value": "CXI | Banana | Cassidy International Airport | Line-Islands | Kiribati"
  },
  {
    "label": "TRW | Tarawa | Bonriki International Airport | Gilbert-Islands | Kiribati",
    "value": "TRW | Tarawa | Bonriki International Airport | Gilbert-Islands | Kiribati"
  },
  {
    "label": "HAH | Moroni | Prince Said Ibrahim International Airport | Grande-Comore | Comoros",
    "value": "HAH | Moroni | Prince Said Ibrahim International Airport | Grande-Comore | Comoros"
  },
  {
    "label": "SKB | Basseterre | Robert L. Bradshaw International Airport | Saint-George-Basseterre | Saint Kitts and Nevis",
    "value": "SKB | Basseterre | Robert L. Bradshaw International Airport | Saint-George-Basseterre | Saint Kitts and Nevis"
  },
  {
    "label": "NEV | Charlestown | Vance W. Amory International Airport | Saint-James-Windwa | Saint Kitts and Nevis",
    "value": "NEV | Charlestown | Vance W. Amory International Airport | Saint-James-Windwa | Saint Kitts and Nevis"
  },
  {
    "label": "FNJ | Pyongyang | Sunan International Airport | South-Pyongan | Korea | Democratic People's Republic of",
    "value": "FNJ | Pyongyang | Sunan International Airport | South-Pyongan | Korea | Democratic People's Republic of"
  },
  {
    "label": "PUS | Busan | Gimhae International Airport | Busan | Korea | Republic of",
    "value": "PUS | Busan | Gimhae International Airport | Busan | Korea | Republic of"
  },
  {
    "label": "CJJ | Cheongju | Cheongju International Airport | North-Chungcheong | Korea | Republic of",
    "value": "CJJ | Cheongju | Cheongju International Airport | North-Chungcheong | Korea | Republic of"
  },
  {
    "label": "CJU | Jeju City | Jeju International Airport | Jeju-do | Korea | Republic of",
    "value": "CJU | Jeju City | Jeju International Airport | Jeju-do | Korea | Republic of"
  },
  {
    "label": "GMP | Seoul | Gimpo International Airport | Seoul | Korea | Republic of",
    "value": "GMP | Seoul | Gimpo International Airport | Seoul | Korea | Republic of"
  },
  {
    "label": "ICN | Seoul | Incheon International Airport | Incheon | Korea | Republic of",
    "value": "ICN | Seoul | Incheon International Airport | Incheon | Korea | Republic of"
  },
  {
    "label": "YNY | Sokcho / Gangneung | Yangyang International Airport | Gangwon-do | Korea | Republic of",
    "value": "YNY | Sokcho / Gangneung | Yangyang International Airport | Gangwon-do | Korea | Republic of"
  },
  {
    "label": "PRN | Prishtina | Pristina International Airport | Pristina | ",
    "value": "PRN | Prishtina | Pristina International Airport | Pristina | "
  },
  {
    "label": "KWI | Kuwait City | Kuwait International Airport | Kuwait",
    "value": "KWI | Kuwait City | Kuwait International Airport | Kuwait"
  },
  {
    "label": "CYB | Cayman Brac | Gerrard Smith International Airport | Cayman Islands",
    "value": "CYB | Cayman Brac | Gerrard Smith International Airport | Cayman Islands"
  },
  {
    "label": "GCM | Georgetown | Owen Roberts International Airport | Cayman Islands",
    "value": "GCM | Georgetown | Owen Roberts International Airport | Cayman Islands"
  },
  {
    "label": "TSE | Astana | Astana International Airport | Aqmola | Kazakhstan",
    "value": "TSE | Astana | Astana International Airport | Aqmola | Kazakhstan"
  },
  {
    "label": "LPQ | Luang Phabang | Luang Phabang International Airport | Louangphabang | Lao People's Democratic Republic",
    "value": "LPQ | Luang Phabang | Luang Phabang International Airport | Louangphabang | Lao People's Democratic Republic"
  },
  {
    "label": "PKZ | Pakse | Pakse International Airport | Champasak | Lao People's Democratic Republic",
    "value": "PKZ | Pakse | Pakse International Airport | Champasak | Lao People's Democratic Republic"
  },
  {
    "label": "VTE | Vientiane | Wattay International Airport | Vientiane-Prefecture | Lao People's Democratic Republic",
    "value": "VTE | Vientiane | Wattay International Airport | Vientiane-Prefecture | Lao People's Democratic Republic"
  },
  {
    "label": "BEY | Beirut | Beirut Rafic Hariri International Airport | Mont-Liban | Lebanon",
    "value": "BEY | Beirut | Beirut Rafic Hariri International Airport | Mont-Liban | Lebanon"
  },
  {
    "label": "UVF | Vieux Fort | Hewanorra International Airport | Vieux-Fort | Saint Lucia",
    "value": "UVF | Vieux Fort | Hewanorra International Airport | Vieux-Fort | Saint Lucia"
  },
  {
    "label": "CMB | Colombo | Bandaranaike International Colombo Airport | Western | Sri Lanka",
    "value": "CMB | Colombo | Bandaranaike International Colombo Airport | Western | Sri Lanka"
  },
  {
    "label": "WRZ | Weerawila | Weerawila International Airport | Southern | Sri Lanka",
    "value": "WRZ | Weerawila | Weerawila International Airport | Southern | Sri Lanka"
  },
  {
    "label": "ROB | Monrovia | Roberts International Airport | Margibi | Liberia",
    "value": "ROB | Monrovia | Roberts International Airport | Margibi | Liberia"
  },
  {
    "label": "MSU | Maseru | Moshoeshoe I International Airport | Maseru | Lesotho",
    "value": "MSU | Maseru | Moshoeshoe I International Airport | Maseru | Lesotho"
  },
  {
    "label": "KUN | Kaunas | Kaunas International Airport | Lithuania",
    "value": "KUN | Kaunas | Kaunas International Airport | Lithuania"
  },
  {
    "label": "PLQ | Palanga | Palanga International Airport | Lithuania",
    "value": "PLQ | Palanga | Palanga International Airport | Lithuania"
  },
  {
    "label": "SQQ | Siauliai | Siauliai International Airport | Lithuania",
    "value": "SQQ | Siauliai | Siauliai International Airport | Lithuania"
  },
  {
    "label": "VNO | Vilnius | Vilnius International Airport | Vilnius | Lithuania",
    "value": "VNO | Vilnius | Vilnius International Airport | Vilnius | Lithuania"
  },
  {
    "label": "LUX | Luxembourg | Luxembourg-Findel International Airport | Luxembourg | Luxembourg",
    "value": "LUX | Luxembourg | Luxembourg-Findel International Airport | Luxembourg | Luxembourg"
  },
  {
    "label": "DGP | Daugavpils | Daugavpils Intrenational Airport | Daugavpils-municipality | Latvia",
    "value": "DGP | Daugavpils | Daugavpils Intrenational Airport | Daugavpils-municipality | Latvia"
  },
  {
    "label": "LPX | Liepaja | Liepaja International Airport | Grobina | Latvia",
    "value": "LPX | Liepaja | Liepaja International Airport | Grobina | Latvia"
  },
  {
    "label": "RIX | Riga | Riga International Airport | Marupe | Latvia",
    "value": "RIX | Riga | Riga International Airport | Marupe | Latvia"
  },
  {
    "label": "VNT | Ventspils | Ventspils International Airport | Ventspils | Latvia",
    "value": "VNT | Ventspils | Ventspils International Airport | Ventspils | Latvia"
  },
  {
    "label": "BEN | Benghazi | Benina International Airport | Banghazi | Libya",
    "value": "BEN | Benghazi | Benina International Airport | Banghazi | Libya"
  },
  {
    "label": "TIP | Tripoli | Tripoli International Airport | Libya",
    "value": "TIP | Tripoli | Tripoli International Airport | Libya"
  },
  {
    "label": "CMN | Casablanca | Mohammed V International Airport | Morocco",
    "value": "CMN | Casablanca | Mohammed V International Airport | Morocco"
  },
  {
    "label": "NDR | Nador | Nador International Airport | Oriental | Morocco",
    "value": "NDR | Nador | Nador International Airport | Oriental | Morocco"
  },
  {
    "label": "KIV | Chisinau | Chisinau International Airport | Chișinau-Municipality | Moldova | Republic of",
    "value": "KIV | Chisinau | Chisinau International Airport | Chișinau-Municipality | Moldova | Republic of"
  },
  {
    "label": "BZY | Strymba | Balti International Airport | Balţi | Moldova | Republic of",
    "value": "BZY | Strymba | Balti International Airport | Balţi | Moldova | Republic of"
  },
  {
    "label": "MAJ | Majuro Atoll | Marshall Islands International Airport | Majuro-Atoll | Marshall Islands",
    "value": "MAJ | Majuro Atoll | Marshall Islands International Airport | Majuro-Atoll | Marshall Islands"
  },
  {
    "label": "MDL | Mandalay | Mandalay International Airport | Mandalay | Myanmar",
    "value": "MDL | Mandalay | Mandalay International Airport | Mandalay | Myanmar"
  },
  {
    "label": "RGN | Yangon | Yangon International Airport | Yangon | Myanmar",
    "value": "RGN | Yangon | Yangon International Airport | Yangon | Myanmar"
  },
  {
    "label": "ULN | Ulan Bator | Chinggis Khaan International Airport | Ulaanbaatar | Mongolia",
    "value": "ULN | Ulan Bator | Chinggis Khaan International Airport | Ulaanbaatar | Mongolia"
  },
  {
    "label": "MFM | Taipa | Macau International Airport | Macao",
    "value": "MFM | Taipa | Macau International Airport | Macao"
  },
  {
    "label": "ROP | Rota Island | Rota International Airport | Rota | Northern Mariana Islands",
    "value": "ROP | Rota Island | Rota International Airport | Rota | Northern Mariana Islands"
  },
  {
    "label": "SPN | Saipan Island | Francisco C. Ada Saipan International Airport | Saipan | Northern Mariana Islands",
    "value": "SPN | Saipan Island | Francisco C. Ada Saipan International Airport | Saipan | Northern Mariana Islands"
  },
  {
    "label": "TIQ | Tinian Island | Tinian International Airport | Tinian | Northern Mariana Islands",
    "value": "TIQ | Tinian Island | Tinian International Airport | Tinian | Northern Mariana Islands"
  },
  {
    "label": "FDF | Fort-de-France | Martinique Aime Cesaire International Airport | Martinique | Martinique",
    "value": "FDF | Fort-de-France | Martinique Aime Cesaire International Airport | Martinique | Martinique"
  },
  {
    "label": "ATR | Atar | Atar International Airport | Adrar | Mauritania",
    "value": "ATR | Atar | Atar International Airport | Adrar | Mauritania"
  },
  {
    "label": "NDB | Nouadhibou | Nouadhibou International Airport | Dakhlet-Nouadhibou | Mauritania",
    "value": "NDB | Nouadhibou | Nouadhibou International Airport | Dakhlet-Nouadhibou | Mauritania"
  },
  {
    "label": "NKC | Nouakchott | Nouakchott International Airport | Trarza | Mauritania",
    "value": "NKC | Nouakchott | Nouakchott International Airport | Trarza | Mauritania"
  },
  {
    "label": "MRU | Port Louis | Sir Seewoosagur Ramgoolam International Airport | Grand-Port | Mauritius",
    "value": "MRU | Port Louis | Sir Seewoosagur Ramgoolam International Airport | Grand-Port | Mauritius"
  },
  {
    "label": "GAN | Gan | Gan International Airport | Seenu | Maldives",
    "value": "GAN | Gan | Gan International Airport | Seenu | Maldives"
  },
  {
    "label": "MLE | Male | Male International Airport | Kaafu-Atoll | Maldives",
    "value": "MLE | Male | Male International Airport | Kaafu-Atoll | Maldives"
  },
  {
    "label": "BLZ | Blantyre | Chileka International Airport | Southern-Region | Malawi",
    "value": "BLZ | Blantyre | Chileka International Airport | Southern-Region | Malawi"
  },
  {
    "label": "LLW | Lilongwe | Lilongwe International Airport | Central-Region | Malawi",
    "value": "LLW | Lilongwe | Lilongwe International Airport | Central-Region | Malawi"
  },
  {
    "label": "ACA | Acapulco | General Juan N Alvarez International Airport | Guerrero | Mexico",
    "value": "ACA | Acapulco | General Juan N Alvarez International Airport | Guerrero | Mexico"
  },
  {
    "label": "AGU | Aguascalientes | Jesus Teran International Airport | Aguascalientes | Mexico",
    "value": "AGU | Aguascalientes | Jesus Teran International Airport | Aguascalientes | Mexico"
  },
  {
    "label": "CPE | Campeche | Ingeniero Alberto Acuna Ongay International Airport | Campeche | Mexico",
    "value": "CPE | Campeche | Ingeniero Alberto Acuna Ongay International Airport | Campeche | Mexico"
  },
  {
    "label": "CUN | Cancun | Cancun International Airport | Quintana-Roo | Mexico",
    "value": "CUN | Cancun | Cancun International Airport | Quintana-Roo | Mexico"
  },
  {
    "label": "CTM | Chetumal | Chetumal International Airport | Quintana-Roo | Mexico",
    "value": "CTM | Chetumal | Chetumal International Airport | Quintana-Roo | Mexico"
  },
  {
    "label": "CUU | Chihuahua | General Roberto Fierro Villalobos International Airport | Chihuahua | Mexico",
    "value": "CUU | Chihuahua | General Roberto Fierro Villalobos International Airport | Chihuahua | Mexico"
  },
  {
    "label": "ACN | Ciudad Acuna | Ciudad Acuna New International Airport | Coahuila | Mexico",
    "value": "ACN | Ciudad Acuna | Ciudad Acuna New International Airport | Coahuila | Mexico"
  },
  {
    "label": "CME | Ciudad del Carmen | Ciudad del Carmen International Airport | Campeche | Mexico",
    "value": "CME | Ciudad del Carmen | Ciudad del Carmen International Airport | Campeche | Mexico"
  },
  {
    "label": "CJS | Ciudad Juarez | Abraham Gonzalez International Airport | Chihuahua | Mexico",
    "value": "CJS | Ciudad Juarez | Abraham Gonzalez International Airport | Chihuahua | Mexico"
  },
  {
    "label": "CEN | Ciudad Obregon | Ciudad Obregon International Airport | Sonora | Mexico",
    "value": "CEN | Ciudad Obregon | Ciudad Obregon International Airport | Sonora | Mexico"
  },
  {
    "label": "CVM | Ciudad Victoria | General Pedro Jose Mendez International Airport | Tamaulipas | Mexico",
    "value": "CVM | Ciudad Victoria | General Pedro Jose Mendez International Airport | Tamaulipas | Mexico"
  },
  {
    "label": "CZM | Cozumel | Cozumel International Airport | Quintana-Roo | Mexico",
    "value": "CZM | Cozumel | Cozumel International Airport | Quintana-Roo | Mexico"
  },
  {
    "label": "CUL | Culiacan | Federal de Bachigualato International Airport | Sinaloa | Mexico",
    "value": "CUL | Culiacan | Federal de Bachigualato International Airport | Sinaloa | Mexico"
  },
  {
    "label": "DGO | Durango | General Guadalupe Victoria International Airport | Durango | Mexico",
    "value": "DGO | Durango | General Guadalupe Victoria International Airport | Durango | Mexico"
  },
  {
    "label": "GDL | Guadalajara | Don Miguel Hidalgo Y Costilla International Airport | Jalisco | Mexico",
    "value": "GDL | Guadalajara | Don Miguel Hidalgo Y Costilla International Airport | Jalisco | Mexico"
  },
  {
    "label": "GYM | Guaymas | General Jose Maria Yanez International Airport | Sonora | Mexico",
    "value": "GYM | Guaymas | General Jose Maria Yanez International Airport | Sonora | Mexico"
  },
  {
    "label": "HMO | Hermosillo | General Ignacio P. Garcia International Airport | Sonora | Mexico",
    "value": "HMO | Hermosillo | General Ignacio P. Garcia International Airport | Sonora | Mexico"
  },
  {
    "label": "HUX | Huatulco | Bahias de Huatulco International Airport | Oaxaca | Mexico",
    "value": "HUX | Huatulco | Bahias de Huatulco International Airport | Oaxaca | Mexico"
  },
  {
    "label": "ZIH | Ixtapa | Ixtapa Zihuatanejo International Airport | Guerrero | Mexico",
    "value": "ZIH | Ixtapa | Ixtapa Zihuatanejo International Airport | Guerrero | Mexico"
  },
  {
    "label": "LAP | La Paz | Manuel Marquez de Leon International Airport | Baja-California-Sur | Mexico",
    "value": "LAP | La Paz | Manuel Marquez de Leon International Airport | Baja-California-Sur | Mexico"
  },
  {
    "label": "LTO | Loreto | Loreto International Airport | Baja-California-Sur | Mexico",
    "value": "LTO | Loreto | Loreto International Airport | Baja-California-Sur | Mexico"
  },
  {
    "label": "LMM | Los Mochis | Valle del Fuerte International Airport | Sinaloa | Mexico",
    "value": "LMM | Los Mochis | Valle del Fuerte International Airport | Sinaloa | Mexico"
  },
  {
    "label": "ZLO | Manzanillo | Playa De Oro International Airport | Colima | Mexico",
    "value": "ZLO | Manzanillo | Playa De Oro International Airport | Colima | Mexico"
  },
  {
    "label": "MAM | Matamoros | General Servando Canales International Airport | Tamaulipas | Mexico",
    "value": "MAM | Matamoros | General Servando Canales International Airport | Tamaulipas | Mexico"
  },
  {
    "label": "MZT | Mazatlan | General Rafael Buelna International Airport | Sinaloa | Mexico",
    "value": "MZT | Mazatlan | General Rafael Buelna International Airport | Sinaloa | Mexico"
  },
  {
    "label": "MXL | Mexicali | General Rodolfo Sanchez Taboada International Airport | Baja-California | Mexico",
    "value": "MXL | Mexicali | General Rodolfo Sanchez Taboada International Airport | Baja-California | Mexico"
  },
  {
    "label": "MEX | Mexico City | Licenciado Benito Juarez International Airport | Mexico-City | Mexico",
    "value": "MEX | Mexico City | Licenciado Benito Juarez International Airport | Mexico-City | Mexico"
  },
  {
    "label": "MTY | Monterrey | General Mariano Escobedo International Airport | Nuevo-Leon | Mexico",
    "value": "MTY | Monterrey | General Mariano Escobedo International Airport | Nuevo-Leon | Mexico"
  },
  {
    "label": "MLM | Morelia | General Francisco J. Mujica International Airport | Michoacan | Mexico",
    "value": "MLM | Morelia | General Francisco J. Mujica International Airport | Michoacan | Mexico"
  },
  {
    "label": "NLD | Nuevo Laredo | Quetzalcoatl International Airport | Tamaulipas | Mexico",
    "value": "NLD | Nuevo Laredo | Quetzalcoatl International Airport | Tamaulipas | Mexico"
  },
  {
    "label": "OAX | Oaxaca | Xoxocotlan International Airport | Oaxaca | Mexico",
    "value": "OAX | Oaxaca | Xoxocotlan International Airport | Oaxaca | Mexico"
  },
  {
    "label": "PBC | Puebla | Hermanos Serdan International Airport | Puebla | Mexico",
    "value": "PBC | Puebla | Hermanos Serdan International Airport | Puebla | Mexico"
  },
  {
    "label": "PXM | Puerto Escondido | Puerto Escondido International Airport | Oaxaca | Mexico",
    "value": "PXM | Puerto Escondido | Puerto Escondido International Airport | Oaxaca | Mexico"
  },
  {
    "label": "PPE | Puerto Penasco | Puerto Penasco International Airport | Sonora | Mexico",
    "value": "PPE | Puerto Penasco | Puerto Penasco International Airport | Sonora | Mexico"
  },
  {
    "label": "PVR | Puerto Vallarta | Licenciado Gustavo Diaz Ordaz International Airport | Jalisco | Mexico",
    "value": "PVR | Puerto Vallarta | Licenciado Gustavo Diaz Ordaz International Airport | Jalisco | Mexico"
  },
  {
    "label": "QRO | Queretaro | Queretaro Intercontinental Airport | Queretaro | Mexico",
    "value": "QRO | Queretaro | Queretaro Intercontinental Airport | Queretaro | Mexico"
  },
  {
    "label": "REX | Reynosa | General Lucio Blanco International Airport | Tamaulipas | Mexico",
    "value": "REX | Reynosa | General Lucio Blanco International Airport | Tamaulipas | Mexico"
  },
  {
    "label": "SLW | Saltillo | Plan De Guadalupe International Airport | Coahuila | Mexico",
    "value": "SLW | Saltillo | Plan De Guadalupe International Airport | Coahuila | Mexico"
  },
  {
    "label": "SJD | San Jose del Cabo | Los Cabos International Airport | Baja-California-Sur | Mexico",
    "value": "SJD | San Jose del Cabo | Los Cabos International Airport | Baja-California-Sur | Mexico"
  },
  {
    "label": "SLP | San Luis Potosi | Ponciano Arriaga International Airport | San-Luis-Potosi | Mexico",
    "value": "SLP | San Luis Potosi | Ponciano Arriaga International Airport | San-Luis-Potosi | Mexico"
  },
  {
    "label": "BJX | Silao | Del Bajio International Airport | Guanajuato | Mexico",
    "value": "BJX | Silao | Del Bajio International Airport | Guanajuato | Mexico"
  },
  {
    "label": "TAM | Tampico | General Francisco Javier Mina International Airport | Tamaulipas | Mexico",
    "value": "TAM | Tampico | General Francisco Javier Mina International Airport | Tamaulipas | Mexico"
  },
  {
    "label": "TAP | Tapachula | Tapachula International Airport | Chiapas | Mexico",
    "value": "TAP | Tapachula | Tapachula International Airport | Chiapas | Mexico"
  },
  {
    "label": "TPQ | Tepic | Amado Nervo National Airport | Nayarit | Mexico",
    "value": "TPQ | Tepic | Amado Nervo National Airport | Nayarit | Mexico"
  },
  {
    "label": "TIJ | Tijuana | General Abelardo L. Rodriguez International Airport | Baja-California-Sur | Mexico",
    "value": "TIJ | Tijuana | General Abelardo L. Rodriguez International Airport | Baja-California-Sur | Mexico"
  },
  {
    "label": "TLC | Toluca | Licenciado Adolfo Lopez Mateos International Airport | Mexico | Mexico",
    "value": "TLC | Toluca | Licenciado Adolfo Lopez Mateos International Airport | Mexico | Mexico"
  },
  {
    "label": "TRC | Torreon | Francisco Sarabia International Airport | Coahuila | Mexico",
    "value": "TRC | Torreon | Francisco Sarabia International Airport | Coahuila | Mexico"
  },
  {
    "label": "TGZ | Tuxtla Gutierrez | Angel Albino Corzo International Airport | Chiapas | Mexico",
    "value": "TGZ | Tuxtla Gutierrez | Angel Albino Corzo International Airport | Chiapas | Mexico"
  },
  {
    "label": "VER | Veracruz | General Heriberto Jara International Airport | Veracruz | Mexico",
    "value": "VER | Veracruz | General Heriberto Jara International Airport | Veracruz | Mexico"
  },
  {
    "label": "VSA | Villahermosa | Carlos Rovirosa Perez International Airport | Tabasco | Mexico",
    "value": "VSA | Villahermosa | Carlos Rovirosa Perez International Airport | Tabasco | Mexico"
  },
  {
    "label": "ZCL | Zacatecas | General Leobardo C. Ruiz International Airport | Zacatecas | Mexico",
    "value": "ZCL | Zacatecas | General Leobardo C. Ruiz International Airport | Zacatecas | Mexico"
  },
  {
    "label": "BKI | Kota Kinabalu | Kota Kinabalu International Airport | Sabah | Malaysia",
    "value": "BKI | Kota Kinabalu | Kota Kinabalu International Airport | Sabah | Malaysia"
  },
  {
    "label": "KUL | Kuala Lumpur | Kuala Lumpur International Airport | Malaysia",
    "value": "KUL | Kuala Lumpur | Kuala Lumpur International Airport | Malaysia"
  },
  {
    "label": "KCH | Kuching | Kuching International Airport | Sarawak | Malaysia",
    "value": "KCH | Kuching | Kuching International Airport | Sarawak | Malaysia"
  },
  {
    "label": "LGK | Langkawi | Langkawi International Airport | Kedah | Malaysia",
    "value": "LGK | Langkawi | Langkawi International Airport | Kedah | Malaysia"
  },
  {
    "label": "PEN | Penang | Penang International Airport | Malaysia",
    "value": "PEN | Penang | Penang International Airport | Malaysia"
  },
  {
    "label": "JHB | Senai | Senai International Airport | Johor | Malaysia",
    "value": "JHB | Senai | Senai International Airport | Johor | Malaysia"
  },
  {
    "label": "SZB | Subang | Sultan Abdul Aziz Shah International Airport | Malaysia",
    "value": "SZB | Subang | Sultan Abdul Aziz Shah International Airport | Malaysia"
  },
  {
    "label": "WDH | Windhoek | Hosea Kutako International Airport | Khomas | Namibia",
    "value": "WDH | Windhoek | Hosea Kutako International Airport | Khomas | Namibia"
  },
  {
    "label": "NOU | Noumea | La Tontouta International Airport | South-Province | New Caledonia",
    "value": "NOU | Noumea | La Tontouta International Airport | South-Province | New Caledonia"
  },
  {
    "label": "AJY | Agadez | Mano Dayak International Airport | Agadez | Niger",
    "value": "AJY | Agadez | Mano Dayak International Airport | Agadez | Niger"
  },
  {
    "label": "NIM | Niamey | Diori Hamani International Airport | Niamey | Niger",
    "value": "NIM | Niamey | Diori Hamani International Airport | Niamey | Niger"
  },
  {
    "label": "NLK | Burnt Pine | Norfolk Island International Airport | Norfolk Island",
    "value": "NLK | Burnt Pine | Norfolk Island International Airport | Norfolk Island"
  },
  {
    "label": "ABV | Abuja | Nnamdi Azikiwe International Airport | FCT | Nigeria",
    "value": "ABV | Abuja | Nnamdi Azikiwe International Airport | FCT | Nigeria"
  },
  {
    "label": "ABB | Asaba | Asaba International Airport | Delta | Nigeria",
    "value": "ABB | Asaba | Asaba International Airport | Delta | Nigeria"
  },
  {
    "label": "CBQ | Calabar | Margaret Ekpo International Airport | Cross-River | Nigeria",
    "value": "CBQ | Calabar | Margaret Ekpo International Airport | Cross-River | Nigeria"
  },
  {
    "label": "ENU | Enegu | Akanu Ibiam International Airport | Enugu | Nigeria",
    "value": "ENU | Enegu | Akanu Ibiam International Airport | Enugu | Nigeria"
  },
  {
    "label": "GMO | Gombe | Gombe Lawanti International Airport | Bauchi | Nigeria",
    "value": "GMO | Gombe | Gombe Lawanti International Airport | Bauchi | Nigeria"
  },
  {
    "label": "ILR | Ilorin | Ilorin International Airport | Kwara | Nigeria",
    "value": "ILR | Ilorin | Ilorin International Airport | Kwara | Nigeria"
  },
  {
    "label": "KAN | Kano | Mallam Aminu International Airport | Kano | Nigeria",
    "value": "KAN | Kano | Mallam Aminu International Airport | Kano | Nigeria"
  },
  {
    "label": "LOS | Lagos | Murtala Muhammed International Airport | Lagos | Nigeria",
    "value": "LOS | Lagos | Murtala Muhammed International Airport | Lagos | Nigeria"
  },
  {
    "label": "MIU | Maiduguri | Maiduguri International Airport | Borno | Nigeria",
    "value": "MIU | Maiduguri | Maiduguri International Airport | Borno | Nigeria"
  },
  {
    "label": "QOW | Owerri | Sam Mbakwe International Airport | Imo | Nigeria",
    "value": "QOW | Owerri | Sam Mbakwe International Airport | Imo | Nigeria"
  },
  {
    "label": "PHC | Port Harcourt | Port Harcourt International Airport | Rivers | Nigeria",
    "value": "PHC | Port Harcourt | Port Harcourt International Airport | Rivers | Nigeria"
  },
  {
    "label": "SKO | Sokoto | Sadiq Abubakar III International Airport | Sokoto | Nigeria",
    "value": "SKO | Sokoto | Sadiq Abubakar III International Airport | Sokoto | Nigeria"
  },
  {
    "label": "MGA | Managua | Augusto C. Sandino (Managua) International Airport | Managua | Nicaragua",
    "value": "MGA | Managua | Augusto C. Sandino (Managua) International Airport | Managua | Nicaragua"
  },
  {
    "label": "KTM | Kathmandu | Tribhuvan International Airport | Central-Region | Nepal",
    "value": "KTM | Kathmandu | Tribhuvan International Airport | Central-Region | Nepal"
  },
  {
    "label": "INU | Yaren District | Nauru International Airport | Yaren | Nauru",
    "value": "INU | Yaren District | Nauru International Airport | Yaren | Nauru"
  },
  {
    "label": "IUE | Alofi | Niue International Airport | Niue",
    "value": "IUE | Alofi | Niue International Airport | Niue"
  },
  {
    "label": "AKL | Auckland | Auckland International Airport | Auckland | New Zealand",
    "value": "AKL | Auckland | Auckland International Airport | Auckland | New Zealand"
  },
  {
    "label": "CHC | Christchurch | Christchurch International Airport | Canterbury | New Zealand",
    "value": "CHC | Christchurch | Christchurch International Airport | Canterbury | New Zealand"
  },
  {
    "label": "HLZ | Hamilton | Hamilton International Airport | Waikato | New Zealand",
    "value": "HLZ | Hamilton | Hamilton International Airport | Waikato | New Zealand"
  },
  {
    "label": "ZQN | Queenstown | Queenstown International Airport | Otago | New Zealand",
    "value": "ZQN | Queenstown | Queenstown International Airport | Otago | New Zealand"
  },
  {
    "label": "WLG | Wellington | Wellington International Airport | Wellington | New Zealand",
    "value": "WLG | Wellington | Wellington International Airport | Wellington | New Zealand"
  },
  {
    "label": "DQM | Duqm | Duqm International Airport | Duqm | Oman",
    "value": "DQM | Duqm | Duqm International Airport | Duqm | Oman"
  },
  {
    "label": "MCT | Muscat | Muscat International Airport | Muscat | Oman",
    "value": "MCT | Muscat | Muscat International Airport | Muscat | Oman"
  },
  {
    "label": "PAC | Albrook | Marcos A. Gelabert International Airport | Panama | Panama",
    "value": "PAC | Albrook | Marcos A. Gelabert International Airport | Panama | Panama"
  },
  {
    "label": "CHX | Changuinola | Cap Manuel Nino International Airport | Bocas-del-Toro | Panama",
    "value": "CHX | Changuinola | Cap Manuel Nino International Airport | Bocas-del-Toro | Panama"
  },
  {
    "label": "DAV | David | Enrique Malek International Airport | Chiriqui | Panama",
    "value": "DAV | David | Enrique Malek International Airport | Chiriqui | Panama"
  },
  {
    "label": "BOC | Isla Colon | Bocas Del Toro International Airport | Bocas-del-Toro | Panama",
    "value": "BOC | Isla Colon | Bocas Del Toro International Airport | Bocas-del-Toro | Panama"
  },
  {
    "label": "BLB | Panama City | Howard/Panama Pacifico International Airport | Panama | Panama",
    "value": "BLB | Panama City | Howard/Panama Pacifico International Airport | Panama | Panama"
  },
  {
    "label": "PTY | Tocumen | Tocumen International Airport | Panama | Panama",
    "value": "PTY | Tocumen | Tocumen International Airport | Panama | Panama"
  },
  {
    "label": "AQP | Arequipa | Rodriguez Ballon International Airport | Arequipa | Peru",
    "value": "AQP | Arequipa | Rodriguez Ballon International Airport | Arequipa | Peru"
  },
  {
    "label": "CIX | Chiclayo | Capitan FAP Jose A Quinones Gonzales International Airport | Lambayeque | Peru",
    "value": "CIX | Chiclayo | Capitan FAP Jose A Quinones Gonzales International Airport | Lambayeque | Peru"
  },
  {
    "label": "CUZ | Cusco | Alejandro Velasco Astete International Airport | Cusco | Peru",
    "value": "CUZ | Cusco | Alejandro Velasco Astete International Airport | Cusco | Peru"
  },
  {
    "label": "IQT | Iquitos | Coronel FAP Francisco Secada Vignetta International Airport | Loreto | Peru",
    "value": "IQT | Iquitos | Coronel FAP Francisco Secada Vignetta International Airport | Loreto | Peru"
  },
  {
    "label": "JUL | Juliaca | Inca Manco Capac International Airport | Puno | Peru",
    "value": "JUL | Juliaca | Inca Manco Capac International Airport | Puno | Peru"
  },
  {
    "label": "LIM | Lima | Jorge Chavez International Airport | Callao | Peru",
    "value": "LIM | Lima | Jorge Chavez International Airport | Callao | Peru"
  },
  {
    "label": "PIO | Pisco | Capitan FAP Renan Elias Olivera International Airport | Ica | Peru",
    "value": "PIO | Pisco | Capitan FAP Renan Elias Olivera International Airport | Ica | Peru"
  },
  {
    "label": "PIU | Piura | Capitan FAP Guillermo Concha Iberico International Airport | Piura | Peru",
    "value": "PIU | Piura | Capitan FAP Guillermo Concha Iberico International Airport | Piura | Peru"
  },
  {
    "label": "PCL | Pucallpa | Cap FAP David Abenzur Rengifo International Airport | Ucayali | Peru",
    "value": "PCL | Pucallpa | Cap FAP David Abenzur Rengifo International Airport | Ucayali | Peru"
  },
  {
    "label": "PEM | Puerto Maldonado | Padre Aldamiz International Airport | Madre-de-Dios | Peru",
    "value": "PEM | Puerto Maldonado | Padre Aldamiz International Airport | Madre-de-Dios | Peru"
  },
  {
    "label": "TCQ | Tacna | Coronel FAP Carlos Ciriani Santa Rosa International Airport | Tacna | Peru",
    "value": "TCQ | Tacna | Coronel FAP Carlos Ciriani Santa Rosa International Airport | Tacna | Peru"
  },
  {
    "label": "TRU | Trujillo | Capitan FAP Carlos Martinez De Pinillos International Airport | La-Libertad | Peru",
    "value": "TRU | Trujillo | Capitan FAP Carlos Martinez De Pinillos International Airport | La-Libertad | Peru"
  },
  {
    "label": "PPT | Papeete | Faa'a International Airport | Iles-du-Vent | French Polynesia",
    "value": "PPT | Papeete | Faa'a International Airport | Iles-du-Vent | French Polynesia"
  },
  {
    "label": "POM | Port Moresby | Port Moresby Jacksons International Airport | National Capital | Papua New Guinea",
    "value": "POM | Port Moresby | Port Moresby Jacksons International Airport | National Capital | Papua New Guinea"
  },
  {
    "label": "WWK | Wewak | Wewak International Airport | East Sepik | Papua New Guinea",
    "value": "WWK | Wewak | Wewak International Airport | East Sepik | Papua New Guinea"
  },
  {
    "label": "CRK | Angeles City | Diosdado Macapagal International Airport | Central-Luzon | Philippines",
    "value": "CRK | Angeles City | Diosdado Macapagal International Airport | Central-Luzon | Philippines"
  },
  {
    "label": "BCD | Bacolod City | Bacolod-Silay City International Airport | Negros-Island-Region | Philippines",
    "value": "BCD | Bacolod City | Bacolod-Silay City International Airport | Negros-Island-Region | Philippines"
  },
  {
    "label": "DVO | Davao City | Francisco Bangoy International Airport | Davao | Philippines",
    "value": "DVO | Davao City | Francisco Bangoy International Airport | Davao | Philippines"
  },
  {
    "label": "GES | General Santos City | General Santos International Airport | Soccsksargen | Philippines",
    "value": "GES | General Santos City | General Santos International Airport | Soccsksargen | Philippines"
  },
  {
    "label": "KLO | Kalibo | Kalibo International Airport | Western-Visayas | Philippines",
    "value": "KLO | Kalibo | Kalibo International Airport | Western-Visayas | Philippines"
  },
  {
    "label": "LAO | Laoag City | Laoag International Airport | Ilocos | Philippines",
    "value": "LAO | Laoag City | Laoag International Airport | Ilocos | Philippines"
  },
  {
    "label": "CEB | Lapu-Lapu City | Mactan Cebu International Airport | Central-Visayas | Philippines",
    "value": "CEB | Lapu-Lapu City | Mactan Cebu International Airport | Central-Visayas | Philippines"
  },
  {
    "label": "LGP | Legazpi City | Legazpi City International Airport | Bicol | Philippines",
    "value": "LGP | Legazpi City | Legazpi City International Airport | Bicol | Philippines"
  },
  {
    "label": "MNL | Manila | Ninoy Aquino International Airport | Philippines",
    "value": "MNL | Manila | Ninoy Aquino International Airport | Philippines"
  },
  {
    "label": "SFS | Olongapo City | Subic Bay International Airport | Central-Luzon | Philippines",
    "value": "SFS | Olongapo City | Subic Bay International Airport | Central-Luzon | Philippines"
  },
  {
    "label": "ZAM | Zamboanga City | Zamboanga International Airport | Zamboanga-Peninsula | Philippines",
    "value": "ZAM | Zamboanga City | Zamboanga International Airport | Zamboanga-Peninsula | Philippines"
  },
  {
    "label": "LYP | Faisalabad | Faisalabad International Airport | Punjab | Pakistan",
    "value": "LYP | Faisalabad | Faisalabad International Airport | Punjab | Pakistan"
  },
  {
    "label": "GWD | Gwadar | Gwadar International Airport | Balochistan | Pakistan",
    "value": "GWD | Gwadar | Gwadar International Airport | Balochistan | Pakistan"
  },
  {
    "label": "ISB | Islamabad | Benazir Bhutto International Airport | Punjab | Pakistan",
    "value": "ISB | Islamabad | Benazir Bhutto International Airport | Punjab | Pakistan"
  },
  {
    "label": "KHI | Karachi | Jinnah International Airport | Sindh | Pakistan",
    "value": "KHI | Karachi | Jinnah International Airport | Sindh | Pakistan"
  },
  {
    "label": "LHE | Lahore | Alama Iqbal International Airport | Punjab | Pakistan",
    "value": "LHE | Lahore | Alama Iqbal International Airport | Punjab | Pakistan"
  },
  {
    "label": "PEW | Peshawar | Peshawar International Airport | Khyber-Pakhtunkhwa | Pakistan",
    "value": "PEW | Peshawar | Peshawar International Airport | Khyber-Pakhtunkhwa | Pakistan"
  },
  {
    "label": "UET | Quetta | Quetta International Airport | Balochistan | Pakistan",
    "value": "UET | Quetta | Quetta International Airport | Balochistan | Pakistan"
  },
  {
    "label": "TUK | Turbat | Turbat International Airport | Balochistan | Pakistan",
    "value": "TUK | Turbat | Turbat International Airport | Balochistan | Pakistan"
  },
  {
    "label": "SJU | San Juan | Luis Munoz Marin International Airport | Carolina | Puerto Rico",
    "value": "SJU | San Juan | Luis Munoz Marin International Airport | Carolina | Puerto Rico"
  },
  {
    "label": "ASU | Asuncion | Silvio Pettirossi International Airport | Central | Paraguay",
    "value": "ASU | Asuncion | Silvio Pettirossi International Airport | Central | Paraguay"
  },
  {
    "label": "AGT | Ciudad del Este | Guarani International Airport | Alto-Parana | Paraguay",
    "value": "AGT | Ciudad del Este | Guarani International Airport | Alto-Parana | Paraguay"
  },
  {
    "label": "ESG | Mariscal Estigarribia | Dr. Luis Maria Argana International Airport | Boqueron | Paraguay",
    "value": "ESG | Mariscal Estigarribia | Dr. Luis Maria Argana International Airport | Boqueron | Paraguay"
  },
  {
    "label": "PJC | Pedro Juan Caballero | Dr Augusto Roberto Fuster International Airport | Amambay | Paraguay",
    "value": "PJC | Pedro Juan Caballero | Dr Augusto Roberto Fuster International Airport | Amambay | Paraguay"
  },
  {
    "label": "DOH | Doha | Doha International Airport | Baladiyat-ad-Dawḩah | Qatar",
    "value": "DOH | Doha | Doha International Airport | Baladiyat-ad-Dawḩah | Qatar"
  },
  {
    "label": "DOH | Doha | Hamad International Airport | Baladiyat-ad-Dawḩah | Qatar",
    "value": "DOH | Doha | Hamad International Airport | Baladiyat-ad-Dawḩah | Qatar"
  },
  {
    "label": "ARW | Arad | Arad International Airport | Arad | Romania",
    "value": "ARW | Arad | Arad International Airport | Arad | Romania"
  },
  {
    "label": "BBU | Bucharest | Baneasa International Airport | Bucureşti | Romania",
    "value": "BBU | Bucharest | Baneasa International Airport | Bucureşti | Romania"
  },
  {
    "label": "OTP | Bucharest | Henri Coanda International Airport | Ilfov | Romania",
    "value": "OTP | Bucharest | Henri Coanda International Airport | Ilfov | Romania"
  },
  {
    "label": "CLJ | Cluj-Napoca | Cluj-Napoca International Airport | Cluj | Romania",
    "value": "CLJ | Cluj-Napoca | Cluj-Napoca International Airport | Cluj | Romania"
  },
  {
    "label": "CND | Constanta | Mihail Kogalniceanu International Airport | Constanța | Romania",
    "value": "CND | Constanta | Mihail Kogalniceanu International Airport | Constanța | Romania"
  },
  {
    "label": "OMR | Oradea | Oradea International Airport | Bihor | Romania",
    "value": "OMR | Oradea | Oradea International Airport | Bihor | Romania"
  },
  {
    "label": "SBZ | Sibiu | Sibiu International Airport | Sibiu | Romania",
    "value": "SBZ | Sibiu | Sibiu International Airport | Sibiu | Romania"
  },
  {
    "label": "TGM | Targu Mures | Transilvania Targu Mures International Airport | Mureş | Romania",
    "value": "TGM | Targu Mures | Transilvania Targu Mures International Airport | Mureş | Romania"
  },
  {
    "label": "EGO | Belgorod | Belgorod International Airport | Belgorod | Russian Federation",
    "value": "EGO | Belgorod | Belgorod International Airport | Belgorod | Russian Federation"
  },
  {
    "label": "KGP | Kogalym | Kogalym International Airport | Khanty-Mansia | Russian Federation",
    "value": "KGP | Kogalym | Kogalym International Airport | Khanty-Mansia | Russian Federation"
  },
  {
    "label": "KRR | Krasnodar | Krasnodar International Airport | Krasnodarskiy | Russian Federation",
    "value": "KRR | Krasnodar | Krasnodar International Airport | Krasnodarskiy | Russian Federation"
  },
  {
    "label": "MQF | Magnitogorsk | Magnitogorsk International Airport | Bashkortostan | Russian Federation",
    "value": "MQF | Magnitogorsk | Magnitogorsk International Airport | Bashkortostan | Russian Federation"
  },
  {
    "label": "DME | Moscow | Domodedovo International Airport | Moscow-Oblast | Russian Federation",
    "value": "DME | Moscow | Domodedovo International Airport | Moscow-Oblast | Russian Federation"
  },
  {
    "label": "SVO | Moscow | Sheremetyevo International Airport | Moscow-Oblast | Russian Federation",
    "value": "SVO | Moscow | Sheremetyevo International Airport | Moscow-Oblast | Russian Federation"
  },
  {
    "label": "VKO | Moscow | Vnukovo International Airport | Moscow | Russian Federation",
    "value": "VKO | Moscow | Vnukovo International Airport | Moscow | Russian Federation"
  },
  {
    "label": "GOJ | Nizhny Novgorod | Nizhny Novgorod International Airport | Novgorod | Russian Federation",
    "value": "GOJ | Nizhny Novgorod | Nizhny Novgorod International Airport | Novgorod | Russian Federation"
  },
  {
    "label": "ROV | Rostov-on-Don | Platov International Airport | Rostov | Russian Federation",
    "value": "ROV | Rostov-on-Don | Platov International Airport | Rostov | Russian Federation"
  },
  {
    "label": "KUF | Samara | Kurumoch International Airport | Samara | Russian Federation",
    "value": "KUF | Samara | Kurumoch International Airport | Samara | Russian Federation"
  },
  {
    "label": "SIP | Simferopol | Simferopol International Airport | Republic-of-Crimea | Russian Federation",
    "value": "SIP | Simferopol | Simferopol International Airport | Republic-of-Crimea | Russian Federation"
  },
  {
    "label": "AER | Sochi | Sochi International Airport | Krasnodarskiy | Russian Federation",
    "value": "AER | Sochi | Sochi International Airport | Krasnodarskiy | Russian Federation"
  },
  {
    "label": "TJM | Tyumen | Roshchino International Airport | Tyumenskaya | Russian Federation",
    "value": "TJM | Tyumen | Roshchino International Airport | Tyumenskaya | Russian Federation"
  },
  {
    "label": "UFA | Ufa | Ufa International Airport | Bashkortostan | Russian Federation",
    "value": "UFA | Ufa | Ufa International Airport | Bashkortostan | Russian Federation"
  },
  {
    "label": "VVO | Vladivostok | Vladivostok International Airport | Primorskiy | Russian Federation",
    "value": "VVO | Vladivostok | Vladivostok International Airport | Primorskiy | Russian Federation"
  },
  {
    "label": "VOG | Volgograd | Volgograd International Airport | Volgograd | Russian Federation",
    "value": "VOG | Volgograd | Volgograd International Airport | Volgograd | Russian Federation"
  },
  {
    "label": "VOZ | Voronezh | Voronezh International Airport | Voronezj | Russian Federation",
    "value": "VOZ | Voronezh | Voronezh International Airport | Voronezj | Russian Federation"
  },
  {
    "label": "KGL | Kigali | Kigali International Airport | Kigali | Rwanda",
    "value": "KGL | Kigali | Kigali International Airport | Kigali | Rwanda"
  },
  {
    "label": "DMM | Ad Dammam | King Fahd International Airport | Eastern-Province | Saudi Arabia",
    "value": "DMM | Ad Dammam | King Fahd International Airport | Eastern-Province | Saudi Arabia"
  },
  {
    "label": "JED | Jeddah | King Abdulaziz International Airport | Makkah | Saudi Arabia",
    "value": "JED | Jeddah | King Abdulaziz International Airport | Makkah | Saudi Arabia"
  },
  {
    "label": "RUH | Riyadh | King Khaled International Airport | Saudi Arabia",
    "value": "RUH | Riyadh | King Khaled International Airport | Saudi Arabia"
  },
  {
    "label": "HIR | Honiara | Honiara International Airport | Guadalcanal | Solomon Islands",
    "value": "HIR | Honiara | Honiara International Airport | Guadalcanal | Solomon Islands"
  },
  {
    "label": "SEZ | Mahe Island | Seychelles International Airport | Pointe-Larue | Seychelles",
    "value": "SEZ | Mahe Island | Seychelles International Airport | Pointe-Larue | Seychelles"
  },
  {
    "label": "KRT | Khartoum | Khartoum International Airport | Khartoum | Sudan",
    "value": "KRT | Khartoum | Khartoum International Airport | Khartoum | Sudan"
  },
  {
    "label": "PZU | Port Sudan | Port Sudan New International Airport | Red-Sea | Sudan",
    "value": "PZU | Port Sudan | Port Sudan New International Airport | Red-Sea | Sudan"
  },
  {
    "label": "SIN | Singapore | Singapore Changi International Airport | North-East | Singapore",
    "value": "SIN | Singapore | Singapore Changi International Airport | North-East | Singapore"
  },
  {
    "label": "BTE | Bonthe | Sherbro International Airport | Southern-Province | Sierra Leone",
    "value": "BTE | Bonthe | Sherbro International Airport | Southern-Province | Sierra Leone"
  },
  {
    "label": "FNA | Freetown | Lungi International Airport | Northern-Province | Sierra Leone",
    "value": "FNA | Freetown | Lungi International Airport | Northern-Province | Sierra Leone"
  },
  {
    "label": "DKR | Dakar | Leopold Sedar Senghor International Airport | Dakar | Senegal",
    "value": "DKR | Dakar | Leopold Sedar Senghor International Airport | Dakar | Senegal"
  },
  {
    "label": "DSS | Diass | Blaise Diagne International Airport | M'bour | Senegal",
    "value": "DSS | Diass | Blaise Diagne International Airport | M'bour | Senegal"
  },
  {
    "label": "HGA | Hargeisa | Egal International Airport | Woqooyi-Galbeed | Somalia",
    "value": "HGA | Hargeisa | Egal International Airport | Woqooyi-Galbeed | Somalia"
  },
  {
    "label": "MGQ | Mogadishu | Aden Adde International Airport | Banaadir | Somalia",
    "value": "MGQ | Mogadishu | Aden Adde International Airport | Banaadir | Somalia"
  },
  {
    "label": "PBM | Zandery | Johan Adolf Pengel International Airport | Para | Suriname",
    "value": "PBM | Zandery | Johan Adolf Pengel International Airport | Para | Suriname"
  },
  {
    "label": "TMS | Sao Tome | Sao Tome International Airport | Sao-Tome-Island | Sao Tome and Principe",
    "value": "TMS | Sao Tome | Sao Tome International Airport | Sao-Tome-Island | Sao Tome and Principe"
  },
  {
    "label": "SAL | Santa Clara | El Salvador International Airport | La-Paz | El Salvador",
    "value": "SAL | Santa Clara | El Salvador International Airport | La-Paz | El Salvador"
  },
  {
    "label": "SXM | Saint Martin | Princess Juliana International Airport | Sint Maarten (Dutch part)",
    "value": "SXM | Saint Martin | Princess Juliana International Airport | Sint Maarten (Dutch part)"
  },
  {
    "label": "ALP | Aleppo | Aleppo International Airport | Aleppo | Syrian Arab Republic",
    "value": "ALP | Aleppo | Aleppo International Airport | Aleppo | Syrian Arab Republic"
  },
  {
    "label": "DAM | Damascus | Damascus International Airport | Rif-dimashq | Syrian Arab Republic",
    "value": "DAM | Damascus | Damascus International Airport | Rif-dimashq | Syrian Arab Republic"
  },
  {
    "label": "LTK | Latakia | Bassel Al-Assad International Airport | Latakia | Syrian Arab Republic",
    "value": "LTK | Latakia | Bassel Al-Assad International Airport | Latakia | Syrian Arab Republic"
  },
  {
    "label": "GDT | Cockburn Town | JAGS McCartney International Airport | Turks and Caicos Islands",
    "value": "GDT | Cockburn Town | JAGS McCartney International Airport | Turks and Caicos Islands"
  },
  {
    "label": "NDJ | N'Djamena | N'Djamena International Airport | Chari-Baguirmi | Chad",
    "value": "NDJ | N'Djamena | N'Djamena International Airport | Chari-Baguirmi | Chad"
  },
  {
    "label": "LRL | Niamtougou | Niamtougou International Airport | Kara | Togo",
    "value": "LRL | Niamtougou | Niamtougou International Airport | Kara | Togo"
  },
  {
    "label": "DMK | Bangkok | Don Mueang International Airport | Bangkok | Thailand",
    "value": "DMK | Bangkok | Don Mueang International Airport | Bangkok | Thailand"
  },
  {
    "label": "CNX | Chiang Mai | Chiang Mai International Airport | Chiang-Mai | Thailand",
    "value": "CNX | Chiang Mai | Chiang Mai International Airport | Chiang-Mai | Thailand"
  },
  {
    "label": "CEI | Chiang Rai | Chiang Rai International Airport | Chiang-Rai | Thailand",
    "value": "CEI | Chiang Rai | Chiang Rai International Airport | Chiang-Rai | Thailand"
  },
  {
    "label": "HDY | Hat Yai | Hat Yai International Airport | Songkhla | Thailand",
    "value": "HDY | Hat Yai | Hat Yai International Airport | Songkhla | Thailand"
  },
  {
    "label": "HKT | Phuket | Phuket International Airport | Phuket | Thailand",
    "value": "HKT | Phuket | Phuket International Airport | Phuket | Thailand"
  },
  {
    "label": "UTP | Rayong | U-Tapao International Airport | Rayong | Thailand",
    "value": "UTP | Rayong | U-Tapao International Airport | Rayong | Thailand"
  },
  {
    "label": "KQT | Kurgan-Tyube | Qurghonteppa International Airport | Khatlon | Tajikistan",
    "value": "KQT | Kurgan-Tyube | Qurghonteppa International Airport | Khatlon | Tajikistan"
  },
  {
    "label": "DIL | Dili | Presidente Nicolau Lobato International Airport | Dili | Timor-Leste",
    "value": "DIL | Dili | Presidente Nicolau Lobato International Airport | Dili | Timor-Leste"
  },
  {
    "label": "DJE | Djerba | Djerba Zarzis International Airport | Madanin | Tunisia",
    "value": "DJE | Djerba | Djerba Zarzis International Airport | Madanin | Tunisia"
  },
  {
    "label": "NBE | Enfidha | Enfidha Zine El Abidine Ben Ali International Airport | Susah | Tunisia",
    "value": "NBE | Enfidha | Enfidha Zine El Abidine Ben Ali International Airport | Susah | Tunisia"
  },
  {
    "label": "GAE | Gabes | Gabes Matmata International Airport | Qabis | Tunisia",
    "value": "GAE | Gabes | Gabes Matmata International Airport | Qabis | Tunisia"
  },
  {
    "label": "GAF | Gafsa | Gafsa Ksar International Airport | Gafsa | Tunisia",
    "value": "GAF | Gafsa | Gafsa Ksar International Airport | Gafsa | Tunisia"
  },
  {
    "label": "MIR | Monastir | Monastir Habib Bourguiba International Airport | Al-Munastir | Tunisia",
    "value": "MIR | Monastir | Monastir Habib Bourguiba International Airport | Al-Munastir | Tunisia"
  },
  {
    "label": "SFA | Sfax | Sfax Thyna International Airport | Safaqis | Tunisia",
    "value": "SFA | Sfax | Sfax Thyna International Airport | Safaqis | Tunisia"
  },
  {
    "label": "TOE | Tozeur | Tozeur Nefta International Airport | Tawzar | Tunisia",
    "value": "TOE | Tozeur | Tozeur Nefta International Airport | Tawzar | Tunisia"
  },
  {
    "label": "TUN | Tunis | Tunis Carthage International Airport | Tunis | Tunisia",
    "value": "TUN | Tunis | Tunis Carthage International Airport | Tunis | Tunisia"
  },
  {
    "label": "TBU | Nuku'alofa | Fua'amotu International Airport | Tongatapu | Tonga",
    "value": "TBU | Nuku'alofa | Fua'amotu International Airport | Tongatapu | Tonga"
  },
  {
    "label": "VAV | Vava'u Island | Vava'u International Airport | Vava‘u | Tonga",
    "value": "VAV | Vava'u Island | Vava'u International Airport | Vava‘u | Tonga"
  },
  {
    "label": "ESB | Ankara | Esenboga International Airport | Ankara | Turkey",
    "value": "ESB | Ankara | Esenboga International Airport | Ankara | Turkey"
  },
  {
    "label": "AYT | Antalya | Antalya International Airport | Antalya | Turkey",
    "value": "AYT | Antalya | Antalya International Airport | Antalya | Turkey"
  },
  {
    "label": "BJV | Bodrum | Milas Bodrum International Airport | Mugla | Turkey",
    "value": "BJV | Bodrum | Milas Bodrum International Airport | Mugla | Turkey"
  },
  {
    "label": "DLM | Dalaman | Dalaman International Airport | Mugla | Turkey",
    "value": "DLM | Dalaman | Dalaman International Airport | Mugla | Turkey"
  },
  {
    "label": "ERZ | Erzurum | Erzurum International Airport | Erzurum | Turkey",
    "value": "ERZ | Erzurum | Erzurum International Airport | Erzurum | Turkey"
  },
  {
    "label": "GZT | Gaziantep | Gaziantep International Airport | Gaziantep | Turkey",
    "value": "GZT | Gaziantep | Gaziantep International Airport | Gaziantep | Turkey"
  },
  {
    "label": "ISE | Isparta | Suleyman Demirel International Airport | Isparta | Turkey",
    "value": "ISE | Isparta | Suleyman Demirel International Airport | Isparta | Turkey"
  },
  {
    "label": "ISL | Istanbul | Ataturk International Airport | Istanbul | Turkey",
    "value": "ISL | Istanbul | Ataturk International Airport | Istanbul | Turkey"
  },
  {
    "label": "SAW | Istanbul | Sabiha Gokcen International Airport | Istanbul | Turkey",
    "value": "SAW | Istanbul | Sabiha Gokcen International Airport | Istanbul | Turkey"
  },
  {
    "label": "ADB | Izmir | Adnan Menderes International Airport | Izmir | Turkey",
    "value": "ADB | Izmir | Adnan Menderes International Airport | Izmir | Turkey"
  },
  {
    "label": "NAV | Nevsehir | Nevsehir Kapadokya International Airport | Nevşehir | Turkey",
    "value": "NAV | Nevsehir | Nevsehir Kapadokya International Airport | Nevşehir | Turkey"
  },
  {
    "label": "TZX | Trabzon | Trabzon International Airport | Trabzon | Turkey",
    "value": "TZX | Trabzon | Trabzon International Airport | Trabzon | Turkey"
  },
  {
    "label": "POS | Port of Spain | Piarco International Airport | Tunapuna/Piarco | Trinidad and Tobago",
    "value": "POS | Port of Spain | Piarco International Airport | Tunapuna/Piarco | Trinidad and Tobago"
  },
  {
    "label": "FUN | Funafuti | Funafuti International Airport | Funafuti | Tuvalu",
    "value": "FUN | Funafuti | Funafuti International Airport | Funafuti | Tuvalu"
  },
  {
    "label": "KHH | Kaohsiung City | Kaohsiung International Airport | Takao | Taiwan | Province of China",
    "value": "KHH | Kaohsiung City | Kaohsiung International Airport | Takao | Taiwan | Province of China"
  },
  {
    "label": "TPE | Taipei | Taiwan Taoyuan International Airport | Taiwan | Taiwan | Province of China",
    "value": "TPE | Taipei | Taiwan Taoyuan International Airport | Taiwan | Taiwan | Province of China"
  },
  {
    "label": "JRO | Arusha | Kilimanjaro International Airport | Kilimanjaro | Tanzania | United Republic of",
    "value": "JRO | Arusha | Kilimanjaro International Airport | Kilimanjaro | Tanzania | United Republic of"
  },
  {
    "label": "DAR | Dar es Salaam | Mwalimu Julius K. Nyerere International Airport | Dar-es-Salaam | Tanzania | United Republic of",
    "value": "DAR | Dar es Salaam | Mwalimu Julius K. Nyerere International Airport | Dar-es-Salaam | Tanzania | United Republic of"
  },
  {
    "label": "CKC | Cherkasy | Cherkasy International Airport | Cherkasy | Ukraine",
    "value": "CKC | Cherkasy | Cherkasy International Airport | Cherkasy | Ukraine"
  },
  {
    "label": "CWC | Chernivtsi | Chernivtsi International Airport | Chernivtsi | Ukraine",
    "value": "CWC | Chernivtsi | Chernivtsi International Airport | Chernivtsi | Ukraine"
  },
  {
    "label": "DNK | Dnipropetrovsk | Dnipropetrovsk International Airport | Dnipro | Ukraine",
    "value": "DNK | Dnipropetrovsk | Dnipropetrovsk International Airport | Dnipro | Ukraine"
  },
  {
    "label": "DOK | Donetsk | Donetsk International Airport | Donetsk | Ukraine",
    "value": "DOK | Donetsk | Donetsk International Airport | Donetsk | Ukraine"
  },
  {
    "label": "IFO | Ivano-Frankivsk | Ivano-Frankivsk International Airport | Ivano-Frankivsk | Ukraine",
    "value": "IFO | Ivano-Frankivsk | Ivano-Frankivsk International Airport | Ivano-Frankivsk | Ukraine"
  },
  {
    "label": "HRK | Kharkiv | Kharkiv International Airport | Kharkiv | Ukraine",
    "value": "HRK | Kharkiv | Kharkiv International Airport | Kharkiv | Ukraine"
  },
  {
    "label": "KBP | Kiev | Boryspil International Airport | Kyiv | Ukraine",
    "value": "KBP | Kiev | Boryspil International Airport | Kyiv | Ukraine"
  },
  {
    "label": "IEV | Kiev | Kiev Zhuliany International Airport | Kyiv-City | Ukraine",
    "value": "IEV | Kiev | Kiev Zhuliany International Airport | Kyiv-City | Ukraine"
  },
  {
    "label": "KWG | Kryvyi Rih | Kryvyi Rih International Airport | Kropyvnytskyi | Ukraine",
    "value": "KWG | Kryvyi Rih | Kryvyi Rih International Airport | Kropyvnytskyi | Ukraine"
  },
  {
    "label": "VSG | Luhansk | Luhansk International Airport | Luhansk | Ukraine",
    "value": "VSG | Luhansk | Luhansk International Airport | Luhansk | Ukraine"
  },
  {
    "label": "LWO | Lviv | Lviv International Airport | Lviv | Ukraine",
    "value": "LWO | Lviv | Lviv International Airport | Lviv | Ukraine"
  },
  {
    "label": "MPW | Mariupol | Mariupol International Airport | Donetsk | Ukraine",
    "value": "MPW | Mariupol | Mariupol International Airport | Donetsk | Ukraine"
  },
  {
    "label": "NLV | Nikolayev | Mykolaiv International Airport | Mykolaiv | Ukraine",
    "value": "NLV | Nikolayev | Mykolaiv International Airport | Mykolaiv | Ukraine"
  },
  {
    "label": "ODS | Odessa | Odessa International Airport | Odessa | Ukraine",
    "value": "ODS | Odessa | Odessa International Airport | Odessa | Ukraine"
  },
  {
    "label": "RWN | Rivne | Rivne International Airport | Rivne | Ukraine",
    "value": "RWN | Rivne | Rivne International Airport | Rivne | Ukraine"
  },
  {
    "label": "TNL | Ternopil | Ternopil International Airport | Ternopil | Ukraine",
    "value": "TNL | Ternopil | Ternopil International Airport | Ternopil | Ukraine"
  },
  {
    "label": "UDJ | Uzhhorod | Uzhhorod International Airport | Transcarpathia | Ukraine",
    "value": "UDJ | Uzhhorod | Uzhhorod International Airport | Transcarpathia | Ukraine"
  },
  {
    "label": "OZH | Zaporizhia | Zaporizhzhia International Airport | Zaporizhia | Ukraine",
    "value": "OZH | Zaporizhia | Zaporizhzhia International Airport | Zaporizhia | Ukraine"
  },
  {
    "label": "EBB | Kampala | Entebbe International Airport | Central-Region | Uganda",
    "value": "EBB | Kampala | Entebbe International Airport | Central-Region | Uganda"
  },
  {
    "label": "AKC | Akron | Akron Fulton International Airport | Ohio | United States",
    "value": "AKC | Akron | Akron Fulton International Airport | Ohio | United States"
  },
  {
    "label": "AEX | Alexandria | Alexandria International Airport | Louisiana | United States",
    "value": "AEX | Alexandria | Alexandria International Airport | Louisiana | United States"
  },
  {
    "label": "ABE | Allentown | Lehigh Valley International Airport | Pennsylvania | United States",
    "value": "ABE | Allentown | Lehigh Valley International Airport | Pennsylvania | United States"
  },
  {
    "label": "AMA | Amarillo | Rick Husband Amarillo International Airport | Texas | United States",
    "value": "AMA | Amarillo | Rick Husband Amarillo International Airport | Texas | United States"
  },
  {
    "label": "ANC | Anchorage | Ted Stevens Anchorage International Airport | Alaska | United States",
    "value": "ANC | Anchorage | Ted Stevens Anchorage International Airport | Alaska | United States"
  },
  {
    "label": "ATL | Atlanta | Hartsfield Jackson Atlanta International Airport | Georgia | United States",
    "value": "ATL | Atlanta | Hartsfield Jackson Atlanta International Airport | Georgia | United States"
  },
  {
    "label": "ACY | Atlantic City | Atlantic City International Airport | New-Jersey | United States",
    "value": "ACY | Atlantic City | Atlantic City International Airport | New-Jersey | United States"
  },
  {
    "label": "AUS | Austin | Austin Bergstrom International Airport | Texas | United States",
    "value": "AUS | Austin | Austin Bergstrom International Airport | Texas | United States"
  },
  {
    "label": "BWI | Baltimore | Baltimore/Washington International Thurgood Marshal Airport | Maryland | United States",
    "value": "BWI | Baltimore | Baltimore/Washington International Thurgood Marshal Airport | Maryland | United States"
  },
  {
    "label": "BGR | Bangor | Bangor International Airport | Maine | United States",
    "value": "BGR | Bangor | Bangor International Airport | Maine | United States"
  },
  {
    "label": "BDE | Baudette | Baudette International Airport | Minnesota | United States",
    "value": "BDE | Baudette | Baudette International Airport | Minnesota | United States"
  },
  {
    "label": "BLI | Bellingham | Bellingham International Airport | Washington | United States",
    "value": "BLI | Bellingham | Bellingham International Airport | Washington | United States"
  },
  {
    "label": "BIL | Billings | Billings Logan International Airport | Montana | United States",
    "value": "BIL | Billings | Billings Logan International Airport | Montana | United States"
  },
  {
    "label": "BHM | Birmingham | Birmingham-Shuttlesworth International Airport | Alabama | United States",
    "value": "BHM | Birmingham | Birmingham-Shuttlesworth International Airport | Alabama | United States"
  },
  {
    "label": "BOS | Boston | General Edward Lawrence Logan International Airport | Massachusetts | United States",
    "value": "BOS | Boston | General Edward Lawrence Logan International Airport | Massachusetts | United States"
  },
  {
    "label": "BRO | Brownsville | Brownsville South Padre Island International Airport | Texas | United States",
    "value": "BRO | Brownsville | Brownsville South Padre Island International Airport | Texas | United States"
  },
  {
    "label": "BUF | Buffalo | Buffalo Niagara International Airport | New-York | United States",
    "value": "BUF | Buffalo | Buffalo Niagara International Airport | New-York | United States"
  },
  {
    "label": "IFP | Bullhead City | Laughlin Bullhead International Airport | Arizona | United States",
    "value": "IFP | Bullhead City | Laughlin Bullhead International Airport | Arizona | United States"
  },
  {
    "label": "BTV | Burlington | Burlington International Airport | Vermont | United States",
    "value": "BTV | Burlington | Burlington International Airport | Vermont | United States"
  },
  {
    "label": "CPR | Casper | Casper-Natrona County International Airport | Wyoming | United States",
    "value": "CPR | Casper | Casper-Natrona County International Airport | Wyoming | United States"
  },
  {
    "label": "CHS | Charleston | Charleston Air Force Base-International Airport | South-Carolina | United States",
    "value": "CHS | Charleston | Charleston Air Force Base-International Airport | South-Carolina | United States"
  },
  {
    "label": "CLT | Charlotte | Charlotte Douglas International Airport | North-Carolina | United States",
    "value": "CLT | Charlotte | Charlotte Douglas International Airport | North-Carolina | United States"
  },
  {
    "label": "MDW | Chicago | Chicago Midway International Airport | Illinois | United States",
    "value": "MDW | Chicago | Chicago Midway International Airport | Illinois | United States"
  },
  {
    "label": "ORD | Chicago | Chicago O'Hare International Airport | Illinois | United States",
    "value": "ORD | Chicago | Chicago O'Hare International Airport | Illinois | United States"
  },
  {
    "label": "RFD | Chicago/Rockford | Chicago Rockford International Airport | Illinois | United States",
    "value": "RFD | Chicago/Rockford | Chicago Rockford International Airport | Illinois | United States"
  },
  {
    "label": "CLE | Cleveland | Cleveland Hopkins International Airport | Ohio | United States",
    "value": "CLE | Cleveland | Cleveland Hopkins International Airport | Ohio | United States"
  },
  {
    "label": "CMH | Columbus | Port Columbus International Airport | Ohio | United States",
    "value": "CMH | Columbus | Port Columbus International Airport | Ohio | United States"
  },
  {
    "label": "CRP | Corpus Christi | Corpus Christi International Airport | Texas | United States",
    "value": "CRP | Corpus Christi | Corpus Christi International Airport | Texas | United States"
  },
  {
    "label": "DFW | Dallas-Fort Worth | Dallas Fort Worth International Airport | Texas | United States",
    "value": "DFW | Dallas-Fort Worth | Dallas Fort Worth International Airport | Texas | United States"
  },
  {
    "label": "DAY | Dayton | James M Cox Dayton International Airport | Ohio | United States",
    "value": "DAY | Dayton | James M Cox Dayton International Airport | Ohio | United States"
  },
  {
    "label": "DAB | Daytona Beach | Daytona Beach International Airport | Florida | United States",
    "value": "DAB | Daytona Beach | Daytona Beach International Airport | Florida | United States"
  },
  {
    "label": "DRT | Del Rio | Del Rio International Airport | Texas | United States",
    "value": "DRT | Del Rio | Del Rio International Airport | Texas | United States"
  },
  {
    "label": "DEN | Denver | Denver International Airport | Colorado | United States",
    "value": "DEN | Denver | Denver International Airport | Colorado | United States"
  },
  {
    "label": "DSM | Des Moines | Des Moines International Airport | Iowa | United States",
    "value": "DSM | Des Moines | Des Moines International Airport | Iowa | United States"
  },
  {
    "label": "DUG | Douglas Bisbee | Bisbee Douglas International Airport | Arizona | United States",
    "value": "DUG | Douglas Bisbee | Bisbee Douglas International Airport | Arizona | United States"
  },
  {
    "label": "FAI | Fairbanks | Fairbanks International Airport | Alaska | United States",
    "value": "FAI | Fairbanks | Fairbanks International Airport | Alaska | United States"
  },
  {
    "label": "FAR | Fargo | Hector International Airport | North-Dakota | United States",
    "value": "FAR | Fargo | Hector International Airport | North-Dakota | United States"
  },
  {
    "label": "FNT | Flint | Bishop International Airport | Michigan | United States",
    "value": "FNT | Flint | Bishop International Airport | Michigan | United States"
  },
  {
    "label": "FLL | Fort Lauderdale | Fort Lauderdale Hollywood International Airport | Florida | United States",
    "value": "FLL | Fort Lauderdale | Fort Lauderdale Hollywood International Airport | Florida | United States"
  },
  {
    "label": "RSW | Fort Myers | Southwest Florida International Airport | Florida | United States",
    "value": "RSW | Fort Myers | Southwest Florida International Airport | Florida | United States"
  },
  {
    "label": "FPR | Fort Pierce | St Lucie County International Airport | Florida | United States",
    "value": "FPR | Fort Pierce | St Lucie County International Airport | Florida | United States"
  },
  {
    "label": "FWA | Fort Wayne | Fort Wayne International Airport | Indiana | United States",
    "value": "FWA | Fort Wayne | Fort Wayne International Airport | Indiana | United States"
  },
  {
    "label": "FTW | Fort Worth | Fort Worth Meacham International Airport | Texas | United States",
    "value": "FTW | Fort Worth | Fort Worth Meacham International Airport | Texas | United States"
  },
  {
    "label": "FAT | Fresno | Fresno Yosemite International Airport | California | United States",
    "value": "FAT | Fresno | Fresno Yosemite International Airport | California | United States"
  },
  {
    "label": "GLS | Galveston | Scholes International At Galveston Airport | Texas | United States",
    "value": "GLS | Galveston | Scholes International At Galveston Airport | Texas | United States"
  },
  {
    "label": "GYY | Gary | Gary Chicago International Airport | Indiana | United States",
    "value": "GYY | Gary | Gary Chicago International Airport | Indiana | United States"
  },
  {
    "label": "GGW | Glasgow | Wokal Field Glasgow International Airport | Montana | United States",
    "value": "GGW | Glasgow | Wokal Field Glasgow International Airport | Montana | United States"
  },
  {
    "label": "GFK | Grand Forks | Grand Forks International Airport | North-Dakota | United States",
    "value": "GFK | Grand Forks | Grand Forks International Airport | North-Dakota | United States"
  },
  {
    "label": "GRR | Grand Rapids | Gerald R. Ford International Airport | Michigan | United States",
    "value": "GRR | Grand Rapids | Gerald R. Ford International Airport | Michigan | United States"
  },
  {
    "label": "GTF | Great Falls | Great Falls International Airport | Montana | United States",
    "value": "GTF | Great Falls | Great Falls International Airport | Montana | United States"
  },
  {
    "label": "GRB | Green Bay | Austin Straubel International Airport | Wisconsin | United States",
    "value": "GRB | Green Bay | Austin Straubel International Airport | Wisconsin | United States"
  },
  {
    "label": "GSO | Greensboro | Piedmont Triad International Airport | North-Carolina | United States",
    "value": "GSO | Greensboro | Piedmont Triad International Airport | North-Carolina | United States"
  },
  {
    "label": "GSP | Greenville | Greenville Spartanburg International Airport | South-Carolina | United States",
    "value": "GSP | Greenville | Greenville Spartanburg International Airport | South-Carolina | United States"
  },
  {
    "label": "GPT | Gulfport | Gulfport Biloxi International Airport | Mississippi | United States",
    "value": "GPT | Gulfport | Gulfport Biloxi International Airport | Mississippi | United States"
  },
  {
    "label": "HRL | Harlingen | Valley International Airport | Texas | United States",
    "value": "HRL | Harlingen | Valley International Airport | Texas | United States"
  },
  {
    "label": "MDT | Harrisburg | Harrisburg International Airport | Pennsylvania | United States",
    "value": "MDT | Harrisburg | Harrisburg International Airport | Pennsylvania | United States"
  },
  {
    "label": "BDL | Hartford | Bradley International Airport | Connecticut | United States",
    "value": "BDL | Hartford | Bradley International Airport | Connecticut | United States"
  },
  {
    "label": "CVG | Hebron | Cincinnati Northern Kentucky International Airport | Kentucky | United States",
    "value": "CVG | Hebron | Cincinnati Northern Kentucky International Airport | Kentucky | United States"
  },
  {
    "label": "ITO | Hilo | Hilo International Airport | Hawaii | United States",
    "value": "ITO | Hilo | Hilo International Airport | Hawaii | United States"
  },
  {
    "label": "HNL | Honolulu | Honolulu International Airport | Hawaii | United States",
    "value": "HNL | Honolulu | Honolulu International Airport | Hawaii | United States"
  },
  {
    "label": "HSV | Huntsville | Huntsville International Carl T Jones Field | Alabama | United States",
    "value": "HSV | Huntsville | Huntsville International Carl T Jones Field | Alabama | United States"
  },
  {
    "label": "IND | Indianapolis | Indianapolis International Airport | Indiana | United States",
    "value": "IND | Indianapolis | Indianapolis International Airport | Indiana | United States"
  },
  {
    "label": "JAN | Jackson | Jackson Evers International Airport | Mississippi | United States",
    "value": "JAN | Jackson | Jackson Evers International Airport | Mississippi | United States"
  },
  {
    "label": "JAX | Jacksonville | Jacksonville International Airport | Florida | United States",
    "value": "JAX | Jacksonville | Jacksonville International Airport | Florida | United States"
  },
  {
    "label": "JNU | Juneau | Juneau International Airport | Alaska | United States",
    "value": "JNU | Juneau | Juneau International Airport | Alaska | United States"
  },
  {
    "label": "AZO | Kalamazoo | Kalamazoo Battle Creek International Airport | Michigan | United States",
    "value": "AZO | Kalamazoo | Kalamazoo Battle Creek International Airport | Michigan | United States"
  },
  {
    "label": "FCA | Kalispell | Glacier Park International Airport | Montana | United States",
    "value": "FCA | Kalispell | Glacier Park International Airport | Montana | United States"
  },
  {
    "label": "MCI | Kansas City | Kansas City International Airport | Missouri | United States",
    "value": "MCI | Kansas City | Kansas City International Airport | Missouri | United States"
  },
  {
    "label": "KTN | Ketchikan | Ketchikan International Airport | Alaska | United States",
    "value": "KTN | Ketchikan | Ketchikan International Airport | Alaska | United States"
  },
  {
    "label": "EYW | Key West | Key West International Airport | Florida | United States",
    "value": "EYW | Key West | Key West International Airport | Florida | United States"
  },
  {
    "label": "CWF | Lake Charles | Chennault International Airport | Louisiana | United States",
    "value": "CWF | Lake Charles | Chennault International Airport | Louisiana | United States"
  },
  {
    "label": "LRD | Laredo | Laredo International Airport | Texas | United States",
    "value": "LRD | Laredo | Laredo International Airport | Texas | United States"
  },
  {
    "label": "LRU | Las Cruces | Las Cruces International Airport | New-Mexico | United States",
    "value": "LRU | Las Cruces | Las Cruces International Airport | New-Mexico | United States"
  },
  {
    "label": "LAS | Las Vegas | McCarran International Airport | Nevada | United States",
    "value": "LAS | Las Vegas | McCarran International Airport | Nevada | United States"
  },
  {
    "label": "LAX | Los Angeles | Los Angeles International Airport | California | United States",
    "value": "LAX | Los Angeles | Los Angeles International Airport | California | United States"
  },
  {
    "label": "SDF | Louisville | Louisville International Standiford Field | Kentucky | United States",
    "value": "SDF | Louisville | Louisville International Standiford Field | Kentucky | United States"
  },
  {
    "label": "LBB | Lubbock | Lubbock Preston Smith International Airport | Texas | United States",
    "value": "LBB | Lubbock | Lubbock Preston Smith International Airport | Texas | United States"
  },
  {
    "label": "MQT | Marquette | Sawyer International Airport | Michigan | United States",
    "value": "MQT | Marquette | Sawyer International Airport | Michigan | United States"
  },
  {
    "label": "MSS | Massena | Massena International Richards Field | New-York | United States",
    "value": "MSS | Massena | Massena International Richards Field | New-York | United States"
  },
  {
    "label": "MFE | Mc Allen | Mc Allen Miller International Airport | Texas | United States",
    "value": "MFE | Mc Allen | Mc Allen Miller International Airport | Texas | United States"
  },
  {
    "label": "MFR | Medford | Rogue Valley International Medford Airport | Oregon | United States",
    "value": "MFR | Medford | Rogue Valley International Medford Airport | Oregon | United States"
  },
  {
    "label": "MLB | Melbourne | Melbourne International Airport | Florida | United States",
    "value": "MLB | Melbourne | Melbourne International Airport | Florida | United States"
  },
  {
    "label": "MEM | Memphis | Memphis International Airport | Tennessee | United States",
    "value": "MEM | Memphis | Memphis International Airport | Tennessee | United States"
  },
  {
    "label": "MIA | Miami | Miami International Airport | Florida | United States",
    "value": "MIA | Miami | Miami International Airport | Florida | United States"
  },
  {
    "label": "MAF | Midland | Midland International Airport | Texas | United States",
    "value": "MAF | Midland | Midland International Airport | Texas | United States"
  },
  {
    "label": "MKE | Milwaukee | General Mitchell International Airport | Wisconsin | United States",
    "value": "MKE | Milwaukee | General Mitchell International Airport | Wisconsin | United States"
  },
  {
    "label": "MOT | Minot | Minot International Airport | North-Dakota | United States",
    "value": "MOT | Minot | Minot International Airport | North-Dakota | United States"
  },
  {
    "label": "MSO | Missoula | Missoula International Airport | Montana | United States",
    "value": "MSO | Missoula | Missoula International Airport | Montana | United States"
  },
  {
    "label": "MLI | Moline | Quad City International Airport | Illinois | United States",
    "value": "MLI | Moline | Quad City International Airport | Illinois | United States"
  },
  {
    "label": "MYR | Myrtle Beach | Myrtle Beach International Airport | South-Carolina | United States",
    "value": "MYR | Myrtle Beach | Myrtle Beach International Airport | South-Carolina | United States"
  },
  {
    "label": "BNA | Nashville | Nashville International Airport | Tennessee | United States",
    "value": "BNA | Nashville | Nashville International Airport | Tennessee | United States"
  },
  {
    "label": "MSY | New Orleans | Louis Armstrong New Orleans International Airport | Louisiana | United States",
    "value": "MSY | New Orleans | Louis Armstrong New Orleans International Airport | Louisiana | United States"
  },
  {
    "label": "JFK | New York | John F Kennedy International Airport | New-York | United States",
    "value": "JFK | New York | John F Kennedy International Airport | New-York | United States"
  },
  {
    "label": "LGA | New York | La Guardia Airport | New-York | United States",
    "value": "LGA | New York | La Guardia Airport | New-York | United States"
  },
  {
    "label": "EWR | Newark | Newark Liberty International Airport | New-Jersey | United States",
    "value": "EWR | Newark | Newark Liberty International Airport | New-Jersey | United States"
  },
  {
    "label": "SWF | Newburgh | Stewart International Airport | New-York | United States",
    "value": "SWF | Newburgh | Stewart International Airport | New-York | United States"
  },
  {
    "label": "PHF | Newport News | Newport News Williamsburg International Airport | Virginia | United States",
    "value": "PHF | Newport News | Newport News Williamsburg International Airport | Virginia | United States"
  },
  {
    "label": "IAG | Niagara Falls | Niagara Falls International Airport | New-York | United States",
    "value": "IAG | Niagara Falls | Niagara Falls International Airport | New-York | United States"
  },
  {
    "label": "ORF | Norfolk | Norfolk International Airport | Virginia | United States",
    "value": "ORF | Norfolk | Norfolk International Airport | Virginia | United States"
  },
  {
    "label": "ODC | Oakdale | Oakdale Airport | California | United States",
    "value": "ODC | Oakdale | Oakdale Airport | California | United States"
  },
  {
    "label": "OAK | Oakland | Metropolitan Oakland International Airport | California | United States",
    "value": "OAK | Oakland | Metropolitan Oakland International Airport | California | United States"
  },
  {
    "label": "OGS | Ogdensburg | Ogdensburg International Airport | New-York | United States",
    "value": "OGS | Ogdensburg | Ogdensburg International Airport | New-York | United States"
  },
  {
    "label": "ONT | Ontario | Ontario International Airport | California | United States",
    "value": "ONT | Ontario | Ontario International Airport | California | United States"
  },
  {
    "label": "MCO | Orlando | Orlando International Airport | Florida | United States",
    "value": "MCO | Orlando | Orlando International Airport | Florida | United States"
  },
  {
    "label": "SFB | Orlando | Orlando Sanford International Airport | Florida | United States",
    "value": "SFB | Orlando | Orlando Sanford International Airport | Florida | United States"
  },
  {
    "label": "PSP | Palm Springs | Palm Springs International Airport | California | United States",
    "value": "PSP | Palm Springs | Palm Springs International Airport | California | United States"
  },
  {
    "label": "PFN | Panama City | Panama City-Bay Co International Airport | Florida | United States",
    "value": "PFN | Panama City | Panama City-Bay Co International Airport | Florida | United States"
  },
  {
    "label": "ECP | Panama City Beach | Northwest Florida Beaches International Airport | Florida | United States",
    "value": "ECP | Panama City Beach | Northwest Florida Beaches International Airport | Florida | United States"
  },
  {
    "label": "PHX | Phoenix | Phoenix Sky Harbor International Airport | Arizona | United States",
    "value": "PHX | Phoenix | Phoenix Sky Harbor International Airport | Arizona | United States"
  },
  {
    "label": "PIT | Pittsburgh | Pittsburgh International Airport | Pennsylvania | United States",
    "value": "PIT | Pittsburgh | Pittsburgh International Airport | Pennsylvania | United States"
  },
  {
    "label": "PBG | Plattsburgh | Plattsburgh International Airport | New-York | United States",
    "value": "PBG | Plattsburgh | Plattsburgh International Airport | New-York | United States"
  },
  {
    "label": "PTK | Pontiac | Oakland County International Airport | Michigan | United States",
    "value": "PTK | Pontiac | Oakland County International Airport | Michigan | United States"
  },
  {
    "label": "CLM | Port Angeles | William R Fairchild International Airport | Washington | United States",
    "value": "CLM | Port Angeles | William R Fairchild International Airport | Washington | United States"
  },
  {
    "label": "PDX | Portland | Portland International Airport | Oregon | United States",
    "value": "PDX | Portland | Portland International Airport | Oregon | United States"
  },
  {
    "label": "PWM | Portland | Portland International Jetport Airport | Maine | United States",
    "value": "PWM | Portland | Portland International Jetport Airport | Maine | United States"
  },
  {
    "label": "PSM | Portsmouth | Portsmouth International at Pease Airport | New-Hampshire | United States",
    "value": "PSM | Portsmouth | Portsmouth International at Pease Airport | New-Hampshire | United States"
  },
  {
    "label": "RDU | Raleigh/Durham | Raleigh Durham International Airport | North-Carolina | United States",
    "value": "RDU | Raleigh/Durham | Raleigh Durham International Airport | North-Carolina | United States"
  },
  {
    "label": "RNO | Reno | Reno Tahoe International Airport | Nevada | United States",
    "value": "RNO | Reno | Reno Tahoe International Airport | Nevada | United States"
  },
  {
    "label": "RIC | Richmond | Richmond International Airport | Virginia | United States",
    "value": "RIC | Richmond | Richmond International Airport | Virginia | United States"
  },
  {
    "label": "ROC | Rochester | Greater Rochester International Airport | New-York | United States",
    "value": "ROC | Rochester | Greater Rochester International Airport | New-York | United States"
  },
  {
    "label": "RST | Rochester | Rochester International Airport | Minnesota | United States",
    "value": "RST | Rochester | Rochester International Airport | Minnesota | United States"
  },
  {
    "label": "ROW | Roswell | Roswell International Air Center Airport | New-Mexico | United States",
    "value": "ROW | Roswell | Roswell International Air Center Airport | New-Mexico | United States"
  },
  {
    "label": "SMF | Sacramento | Sacramento International Airport | California | United States",
    "value": "SMF | Sacramento | Sacramento International Airport | California | United States"
  },
  {
    "label": "MBS | Saginaw | MBS International Airport | Michigan | United States",
    "value": "MBS | Saginaw | MBS International Airport | Michigan | United States"
  },
  {
    "label": "SLC | Salt Lake City | Salt Lake City International Airport | Utah | United States",
    "value": "SLC | Salt Lake City | Salt Lake City International Airport | Utah | United States"
  },
  {
    "label": "SAT | San Antonio | San Antonio International Airport | Texas | United States",
    "value": "SAT | San Antonio | San Antonio International Airport | Texas | United States"
  },
  {
    "label": "SAN | San Diego | San Diego International Airport | California | United States",
    "value": "SAN | San Diego | San Diego International Airport | California | United States"
  },
  {
    "label": "SFO | San Francisco | San Francisco International Airport | California | United States",
    "value": "SFO | San Francisco | San Francisco International Airport | California | United States"
  },
  {
    "label": "SJC | San Jose | Norman Y. Mineta San Jose International Airport | California | United States",
    "value": "SJC | San Jose | Norman Y. Mineta San Jose International Airport | California | United States"
  },
  {
    "label": "SRQ | Sarasota/Bradenton | Sarasota Bradenton International Airport | Florida | United States",
    "value": "SRQ | Sarasota/Bradenton | Sarasota Bradenton International Airport | Florida | United States"
  },
  {
    "label": "CIU | Sault Ste Marie | Chippewa County International Airport | Michigan | United States",
    "value": "CIU | Sault Ste Marie | Chippewa County International Airport | Michigan | United States"
  },
  {
    "label": "SAV | Savannah | Savannah Hilton Head International Airport | Georgia | United States",
    "value": "SAV | Savannah | Savannah Hilton Head International Airport | Georgia | United States"
  },
  {
    "label": "BFI | Seattle | Boeing Field King County International Airport | Washington | United States",
    "value": "BFI | Seattle | Boeing Field King County International Airport | Washington | United States"
  },
  {
    "label": "SEA | Seattle | Seattle Tacoma International Airport | Washington | United States",
    "value": "SEA | Seattle | Seattle Tacoma International Airport | Washington | United States"
  },
  {
    "label": "GEG | Spokane | Spokane International Airport | Washington | United States",
    "value": "GEG | Spokane | Spokane International Airport | Washington | United States"
  },
  {
    "label": "STL | St Louis | Lambert St Louis International Airport | Missouri | United States",
    "value": "STL | St Louis | Lambert St Louis International Airport | Missouri | United States"
  },
  {
    "label": "PIE | St Petersburg-Clearwater | St Petersburg Clearwater International Airport | Florida | United States",
    "value": "PIE | St Petersburg-Clearwater | St Petersburg Clearwater International Airport | Florida | United States"
  },
  {
    "label": "SYR | Syracuse | Syracuse Hancock International Airport | New-York | United States",
    "value": "SYR | Syracuse | Syracuse Hancock International Airport | New-York | United States"
  },
  {
    "label": "TPA | Tampa | Tampa International Airport | Florida | United States",
    "value": "TPA | Tampa | Tampa International Airport | Florida | United States"
  },
  {
    "label": "HUF | Terre Haute | Terre Haute International Hulman Field | Indiana | United States",
    "value": "HUF | Terre Haute | Terre Haute International Hulman Field | Indiana | United States"
  },
  {
    "label": "TUS | Tucson | Tucson International Airport | Arizona | United States",
    "value": "TUS | Tucson | Tucson International Airport | Arizona | United States"
  },
  {
    "label": "TUL | Tulsa | Tulsa International Airport | Oklahoma | United States",
    "value": "TUL | Tulsa | Tulsa International Airport | Oklahoma | United States"
  },
  {
    "label": "IAD | Washington | Washington Dulles International Airport | Virginia | United States",
    "value": "IAD | Washington | Washington Dulles International Airport | Virginia | United States"
  },
  {
    "label": "ART | Watertown | Watertown International Airport | New-York | United States",
    "value": "ART | Watertown | Watertown International Airport | New-York | United States"
  },
  {
    "label": "AVP | Wilkes-Barre/Scranton | Wilkes Barre Scranton International Airport | Pennsylvania | United States",
    "value": "AVP | Wilkes-Barre/Scranton | Wilkes Barre Scranton International Airport | Pennsylvania | United States"
  },
  {
    "label": "ISN | Williston | Sloulin Field International Airport | North-Dakota | United States",
    "value": "ISN | Williston | Sloulin Field International Airport | North-Dakota | United States"
  },
  {
    "label": "ILM | Wilmington | Wilmington International Airport | North-Carolina | United States",
    "value": "ILM | Wilmington | Wilmington International Airport | North-Carolina | United States"
  },
  {
    "label": "YUM | Yuma | Yuma MCAS/Yuma International Airport | Arizona | United States",
    "value": "YUM | Yuma | Yuma MCAS/Yuma International Airport | Arizona | United States"
  },
  {
    "label": "ATI | Artigas | Artigas International Airport | Artigas | Uruguay",
    "value": "ATI | Artigas | Artigas International Airport | Artigas | Uruguay"
  },
  {
    "label": "CAR | Carmelo | Carmelo International Airport | Colonia | Uruguay",
    "value": "CAR | Carmelo | Carmelo International Airport | Colonia | Uruguay"
  },
  {
    "label": "CYR | Colonia | Laguna de Los Patos International Airport | Colonia | Uruguay",
    "value": "CYR | Colonia | Laguna de Los Patos International Airport | Colonia | Uruguay"
  },
  {
    "label": "DZO | Durazno | Santa Bernardina International Airport | Durazno | Uruguay",
    "value": "DZO | Durazno | Santa Bernardina International Airport | Durazno | Uruguay"
  },
  {
    "label": "MLZ | Melo | Cerro Largo International Airport | Cerro-Largo | Uruguay",
    "value": "MLZ | Melo | Cerro Largo International Airport | Cerro-Largo | Uruguay"
  },
  {
    "label": "MER | Mercedes | Ricardo de Tomasi International Airport | Soriano | Uruguay",
    "value": "MER | Mercedes | Ricardo de Tomasi International Airport | Soriano | Uruguay"
  },
  {
    "label": "PDP | Punta del Este | Capitan Corbeta CA Curbelo International Airport | Maldonado | Uruguay",
    "value": "PDP | Punta del Este | Capitan Corbeta CA Curbelo International Airport | Maldonado | Uruguay"
  },
  {
    "label": "RVY | Rivera | Presidente General Don Oscar D. Gestido International Airport | Rivera | Uruguay",
    "value": "RVY | Rivera | Presidente General Don Oscar D. Gestido International Airport | Rivera | Uruguay"
  },
  {
    "label": "STY | Salto | Nueva Hesperides International Airport | Salto | Uruguay",
    "value": "STY | Salto | Nueva Hesperides International Airport | Salto | Uruguay"
  },
  {
    "label": "TAS | Tashkent | Tashkent International Airport | Toshkent-Shahri | Uzbekistan",
    "value": "TAS | Tashkent | Tashkent International Airport | Toshkent-Shahri | Uzbekistan"
  },
  {
    "label": "UNI | Union Island | Union Island International Airport | Grenadines | Saint Vincent and the Grenadines",
    "value": "UNI | Union Island | Union Island International Airport | Grenadines | Saint Vincent and the Grenadines"
  },
  {
    "label": "BLA | Barcelona | General Jose Antonio Anzoategui International Airport | Anzoategui | Venezuela | Bolivarian Republic of",
    "value": "BLA | Barcelona | General Jose Antonio Anzoategui International Airport | Anzoategui | Venezuela | Bolivarian Republic of"
  },
  {
    "label": "BRM | Barquisimeto | Barquisimeto International Airport | Lara | Venezuela | Bolivarian Republic of",
    "value": "BRM | Barquisimeto | Barquisimeto International Airport | Lara | Venezuela | Bolivarian Republic of"
  },
  {
    "label": "CCS | Caracas | Maiquetia (Simon Bolivar Internacional) Airport | Vargas | Venezuela | Bolivarian Republic of",
    "value": "CCS | Caracas | Maiquetia (Simon Bolivar Internacional) Airport | Vargas | Venezuela | Bolivarian Republic of"
  },
  {
    "label": "PMV | Isla Margarita | Del Caribe Santiago Marino International Airport | Nueva-Esparta | Venezuela | Bolivarian Republic of",
    "value": "PMV | Isla Margarita | Del Caribe Santiago Marino International Airport | Nueva-Esparta | Venezuela | Bolivarian Republic of"
  },
  {
    "label": "MAR | Maracaibo | La Chinita International Airport | Zulia | Venezuela | Bolivarian Republic of",
    "value": "MAR | Maracaibo | La Chinita International Airport | Zulia | Venezuela | Bolivarian Republic of"
  },
  {
    "label": "LSP | Paraguana | Josefa Camejo International Airport | Falcon | Venezuela | Bolivarian Republic of",
    "value": "LSP | Paraguana | Josefa Camejo International Airport | Falcon | Venezuela | Bolivarian Republic of"
  },
  {
    "label": "PZO | Puerto Ordaz-Ciudad Guayana | General Manuel Carlos Piar International Airport | Bolivar | Venezuela | Bolivarian Republic of",
    "value": "PZO | Puerto Ordaz-Ciudad Guayana | General Manuel Carlos Piar International Airport | Bolivar | Venezuela | Bolivarian Republic of"
  },
  {
    "label": "STD | Santo Domingo | Mayor Buenaventura Vivas International Airport | Tachira | Venezuela | Bolivarian Republic of",
    "value": "STD | Santo Domingo | Mayor Buenaventura Vivas International Airport | Tachira | Venezuela | Bolivarian Republic of"
  },
  {
    "label": "VLN | Valencia | Arturo Michelena International Airport | Carabobo | Venezuela | Bolivarian Republic of",
    "value": "VLN | Valencia | Arturo Michelena International Airport | Carabobo | Venezuela | Bolivarian Republic of"
  },
  {
    "label": "EIS | Road Town | Terrance B. Lettsome International Airport | Virgin Islands | British",
    "value": "EIS | Road Town | Terrance B. Lettsome International Airport | Virgin Islands | British"
  },
  {
    "label": "DAD | Da Nang | Da Nang International Airport | Da-Nẵng | Viet Nam",
    "value": "DAD | Da Nang | Da Nang International Airport | Da-Nẵng | Viet Nam"
  },
  {
    "label": "VCL | Dung Quat Bay | Chu Lai International Airport | Viet Nam",
    "value": "VCL | Dung Quat Bay | Chu Lai International Airport | Viet Nam"
  },
  {
    "label": "HPH | Haiphong | Cat Bi International Airport | Hải-Phong | Viet Nam",
    "value": "HPH | Haiphong | Cat Bi International Airport | Hải-Phong | Viet Nam"
  },
  {
    "label": "HAN | Hanoi | Noi Bai International Airport | Ha-Nội | Viet Nam",
    "value": "HAN | Hanoi | Noi Bai International Airport | Ha-Nội | Viet Nam"
  },
  {
    "label": "SGN | Ho Chi Minh City | Tan Son Nhat International Airport | Ho-Chi-Minh-City | Viet Nam",
    "value": "SGN | Ho Chi Minh City | Tan Son Nhat International Airport | Ho-Chi-Minh-City | Viet Nam"
  },
  {
    "label": "SON | Luganville | Santo Pekoa International Airport | Sanma | Vanuatu",
    "value": "SON | Luganville | Santo Pekoa International Airport | Sanma | Vanuatu"
  },
  {
    "label": "APW | Apia | Faleolo International Airport | A'ana | Samoa",
    "value": "APW | Apia | Faleolo International Airport | A'ana | Samoa"
  },
  {
    "label": "ADE | Aden | Aden International Airport | Aden | Yemen",
    "value": "ADE | Aden | Aden International Airport | Aden | Yemen"
  },
  {
    "label": "HOD | Hodeida | Hodeidah International Airport | Al-Hudaydah | Yemen",
    "value": "HOD | Hodeida | Hodeidah International Airport | Al-Hudaydah | Yemen"
  },
  {
    "label": "RIY | Riyan | Mukalla International Airport | Muḩafaz̧at-Ḩaḑramawt | Yemen",
    "value": "RIY | Riyan | Mukalla International Airport | Muḩafaz̧at-Ḩaḑramawt | Yemen"
  },
  {
    "label": "SAH | Sana'a | Sana'a International Airport | Amanat-Al-Asimah | Yemen",
    "value": "SAH | Sana'a | Sana'a International Airport | Amanat-Al-Asimah | Yemen"
  },
  {
    "label": "GXF | Sayun | Sayun International Airport | Muḩafaz̧at-Ḩaḑramawt | Yemen",
    "value": "GXF | Sayun | Sayun International Airport | Muḩafaz̧at-Ḩaḑramawt | Yemen"
  },
  {
    "label": "SCT | Socotra Islands | Socotra International Airport | Soqatra | Yemen",
    "value": "SCT | Socotra Islands | Socotra International Airport | Soqatra | Yemen"
  },
  {
    "label": "TAI | Ta'izz | Ta'izz International Airport | Ta‘izz | Yemen",
    "value": "TAI | Ta'izz | Ta'izz International Airport | Ta‘izz | Yemen"
  },
  {
    "label": "DZA | Dzaoudzi | Dzaoudzi Pamandzi International Airport | Pamandzi | Mayotte",
    "value": "DZA | Dzaoudzi | Dzaoudzi Pamandzi International Airport | Pamandzi | Mayotte"
  },
  {
    "label": "BFN | Bloemfontain | J B M Hertzog International Airport | Orange-Free-State | South Africa",
    "value": "BFN | Bloemfontain | J B M Hertzog International Airport | Orange-Free-State | South Africa"
  },
  {
    "label": "CPT | Cape Town | Cape Town International Airport | Western-Cape | South Africa",
    "value": "CPT | Cape Town | Cape Town International Airport | Western-Cape | South Africa"
  },
  {
    "label": "DUR | Durban | King Shaka International Airport | KwaZulu-Natal | South Africa",
    "value": "DUR | Durban | King Shaka International Airport | KwaZulu-Natal | South Africa"
  },
  {
    "label": "MBD | Mafeking | Mmabatho International Airport | North-West | South Africa",
    "value": "MBD | Mafeking | Mmabatho International Airport | North-West | South Africa"
  },
  {
    "label": "MQP | Mpumalanga | Kruger Mpumalanga International Airport | Mpumalanga | South Africa",
    "value": "MQP | Mpumalanga | Kruger Mpumalanga International Airport | Mpumalanga | South Africa"
  },
  {
    "label": "NTY | Pilanesberg | Pilanesberg International Airport | North-West | South Africa",
    "value": "NTY | Pilanesberg | Pilanesberg International Airport | North-West | South Africa"
  },
  {
    "label": "PTG | Potgietersrus | Polokwane International Airport | Limpopo | South Africa",
    "value": "PTG | Potgietersrus | Polokwane International Airport | Limpopo | South Africa"
  },
  {
    "label": "LUN | Lusaka | Kenneth Kaunda International Airport | Lusaka | Zambia",
    "value": "LUN | Lusaka | Kenneth Kaunda International Airport | Lusaka | Zambia"
  },
  {
    "label": "BUQ | Bulawayo | Joshua Mqabuko Nkomo International Airport | Matabeleland-North | Zimbabwe",
    "value": "BUQ | Bulawayo | Joshua Mqabuko Nkomo International Airport | Matabeleland-North | Zimbabwe"
  },
  {
    "label": "HRE | Harare | Harare International Airport | Harare | Zimbabwe",
    "value": "HRE | Harare | Harare International Airport | Harare | Zimbabwe"
  },
  {
    "label": "KAB | Kariba | Kariba International Airport | Zimbabwe",
    "value": "KAB | Kariba | Kariba International Airport | Zimbabwe"
  },
  {
    "label": "MVZ | Masvingo | Masvingo International Airport | Masvingo | Zimbabwe",
    "value": "MVZ | Masvingo | Masvingo International Airport | Masvingo | Zimbabwe"
  },
  {
    "label": "VFA | Victoria Falls | Victoria Falls International Airport | Zimbabwe",
    "value": "VFA | Victoria Falls | Victoria Falls International Airport | Zimbabwe"
  },
  {
    "label": "AUH | Abu Dhabi | Abu Dhabi International Airport | Abu-Dhabi | United Arab Emirates",
    "value": "AUH | Abu Dhabi | Abu Dhabi International Airport | Abu-Dhabi | United Arab Emirates"
  },
  {
    "label": "DXB | Dubai | Dubai International Airport | Dubai | United Arab Emirates",
    "value": "DXB | Dubai | Dubai International Airport | Dubai | United Arab Emirates"
  },
  {
    "label": "RKT | Ras Al Khaimah | Ras Al Khaimah International Airport | Raʼs-al-Khaymah | United Arab Emirates",
    "value": "RKT | Ras Al Khaimah | Ras Al Khaimah International Airport | Raʼs-al-Khaymah | United Arab Emirates"
  },
  {
    "label": "SHJ | Sharjah | Sharjah International Airport | Ash-Shariqah | United Arab Emirates",
    "value": "SHJ | Sharjah | Sharjah International Airport | Ash-Shariqah | United Arab Emirates"
  },
  {
    "label": "KBL | Kabul | Kabul International Airport | Kabul | Afghanistan",
    "value": "KBL | Kabul | Kabul International Airport | Kabul | Afghanistan"
  },
  {
    "label": "ANU | St. George | V.C. Bird International Airport | Saint-George | Antigua and Barbuda",
    "value": "ANU | St. George | V.C. Bird International Airport | Saint-George | Antigua and Barbuda"
  },
  {
    "label": "TIA | Tirana | Tirana International Airport Mother Teresa | Albania",
    "value": "TIA | Tirana | Tirana International Airport Mother Teresa | Albania"
  },
  {
    "label": "EVN | Yerevan | Zvartnots International Airport | Armenia",
    "value": "EVN | Yerevan | Zvartnots International Airport | Armenia"
  },
  {
    "label": "EZE | Ezeiza | Ministro Pistarini International Airport | Buenos-Aires | Argentina",
    "value": "EZE | Ezeiza | Ministro Pistarini International Airport | Buenos-Aires | Argentina"
  },
  {
    "label": "MDQ | Mar del Plata | Astor Piazzola International Airport | Buenos-Aires | Argentina",
    "value": "MDQ | Mar del Plata | Astor Piazzola International Airport | Buenos-Aires | Argentina"
  },
  {
    "label": "RLO | Merlo | Valle Del Conlara International Airport | San-Luis | Argentina",
    "value": "RLO | Merlo | Valle Del Conlara International Airport | San-Luis | Argentina"
  },
  {
    "label": "IGR | Puerto Iguazu | Cataratas Del Iguazu International Airport | Misiones | Argentina",
    "value": "IGR | Puerto Iguazu | Cataratas Del Iguazu International Airport | Misiones | Argentina"
  },
  {
    "label": "RGA | Rio Grande | Hermes Quijada International Airport | Tierra-del-Fuego | Argentina",
    "value": "RGA | Rio Grande | Hermes Quijada International Airport | Tierra-del-Fuego | Argentina"
  },
  {
    "label": "SLA | Salta | Martin Miguel De Guemes International Airport | Salta | Argentina",
    "value": "SLA | Salta | Martin Miguel De Guemes International Airport | Salta | Argentina"
  },
  {
    "label": "JUJ | San Salvador de Jujuy | Gobernador Horacio Guzman International Airport | Jujuy | Argentina",
    "value": "JUJ | San Salvador de Jujuy | Gobernador Horacio Guzman International Airport | Jujuy | Argentina"
  },
  {
    "label": "PPG | Pago Pago | Pago Pago International Airport | Eastern-District | American Samoa",
    "value": "PPG | Pago Pago | Pago Pago International Airport | Eastern-District | American Samoa"
  },
  {
    "label": "VIE | Vienna | Vienna International Airport | Lower-Austria | Austria",
    "value": "VIE | Vienna | Vienna International Airport | Lower-Austria | Austria"
  },
  {
    "label": "ADL | Adelaide | Adelaide International Airport | South-Australia | Australia",
    "value": "ADL | Adelaide | Adelaide International Airport | South-Australia | Australia"
  },
  {
    "label": "CNS | Cairns | Cairns International Airport | Queensland | Australia",
    "value": "CNS | Cairns | Cairns International Airport | Queensland | Australia"
  },
  {
    "label": "CBR | Canberra | Canberra International Airport | ACT | Australia",
    "value": "CBR | Canberra | Canberra International Airport | ACT | Australia"
  },
  {
    "label": "DRW | Darwin | Darwin International Airport | Northern-Territory | Australia",
    "value": "DRW | Darwin | Darwin International Airport | Northern-Territory | Australia"
  },
  {
    "label": "HBA | Hobart | Hobart International Airport | Tasmania | Australia",
    "value": "HBA | Hobart | Hobart International Airport | Tasmania | Australia"
  },
  {
    "label": "MEL | Melbourne | Melbourne International Airport | Victoria | Australia",
    "value": "MEL | Melbourne | Melbourne International Airport | Victoria | Australia"
  },
  {
    "label": "PER | Perth | Perth International Airport | Western-Australia | Australia",
    "value": "PER | Perth | Perth International Airport | Western-Australia | Australia"
  },
  {
    "label": "PHE | Port Hedland | Port Hedland International Airport | Western-Australia | Australia",
    "value": "PHE | Port Hedland | Port Hedland International Airport | Western-Australia | Australia"
  },
  {
    "label": "SYD | Sydney | Sydney Kingsford Smith International Airport | New-South-Wales | Australia",
    "value": "SYD | Sydney | Sydney Kingsford Smith International Airport | New-South-Wales | Australia"
  },
  {
    "label": "AUA | Oranjestad | Queen Beatrix International Airport | Aruba",
    "value": "AUA | Oranjestad | Queen Beatrix International Airport | Aruba"
  },
  {
    "label": "GYD | Baku | Heydar Aliyev International Airport | Baki | Azerbaijan",
    "value": "GYD | Baku | Heydar Aliyev International Airport | Baki | Azerbaijan"
  },
  {
    "label": "GBB | Gabala | Gabala International Airport | Qǝbǝlǝ | Azerbaijan",
    "value": "GBB | Gabala | Gabala International Airport | Qǝbǝlǝ | Azerbaijan"
  },
  {
    "label": "LLK | Lankaran | Lankaran International Airport | Lənkəran | Azerbaijan",
    "value": "LLK | Lankaran | Lankaran International Airport | Lənkəran | Azerbaijan"
  },
  {
    "label": "ZTU | Zaqatala | Zaqatala International Airport | Zaqatala | Azerbaijan",
    "value": "ZTU | Zaqatala | Zaqatala International Airport | Zaqatala | Azerbaijan"
  },
  {
    "label": "BNX | Banja Luka | Banja Luka International Airport | Srspka | Bosnia and Herzegovina",
    "value": "BNX | Banja Luka | Banja Luka International Airport | Srspka | Bosnia and Herzegovina"
  },
  {
    "label": "OMO | Mostar | Mostar International Airport | Federation-of-B&H | Bosnia and Herzegovina",
    "value": "OMO | Mostar | Mostar International Airport | Federation-of-B&H | Bosnia and Herzegovina"
  },
  {
    "label": "BGI | Bridgetown | Sir Grantley Adams International Airport | Christ-Church | Barbados",
    "value": "BGI | Bridgetown | Sir Grantley Adams International Airport | Christ-Church | Barbados"
  },
  {
    "label": "CGP | Chittagong | Shah Amanat International Airport | Chittagong | Bangladesh",
    "value": "CGP | Chittagong | Shah Amanat International Airport | Chittagong | Bangladesh"
  },
  {
    "label": "DAC | Dhaka | Dhaka / Hazrat Shahjalal International Airport | Dhaka | Bangladesh",
    "value": "DAC | Dhaka | Dhaka / Hazrat Shahjalal International Airport | Dhaka | Bangladesh"
  },
  {
    "label": "ZYL | Sylhet | Osmany International Airport | Sylhet | Bangladesh",
    "value": "ZYL | Sylhet | Osmany International Airport | Sylhet | Bangladesh"
  },
  {
    "label": "ANR | Antwerp | Antwerp International Airport (Deurne) | Flanders | Belgium",
    "value": "ANR | Antwerp | Antwerp International Airport (Deurne) | Flanders | Belgium"
  },
  {
    "label": "OST | Ostend | Ostend-Bruges International Airport | Flanders | Belgium",
    "value": "OST | Ostend | Ostend-Bruges International Airport | Flanders | Belgium"
  },
  {
    "label": "PDV | Plovdiv | Plovdiv International Airport | Plovdiv | Bulgaria",
    "value": "PDV | Plovdiv | Plovdiv International Airport | Plovdiv | Bulgaria"
  },
  {
    "label": "BAH | Manama | Bahrain International Airport | Muharraq | Bahrain",
    "value": "BAH | Manama | Bahrain International Airport | Muharraq | Bahrain"
  },
  {
    "label": "BJM | Bujumbura | Bujumbura International Airport | Bujumbura-Mairie | Burundi",
    "value": "BJM | Bujumbura | Bujumbura International Airport | Bujumbura-Mairie | Burundi"
  },
  {
    "label": "BDA | Hamilton | L.F. Wade International International Airport | Saint-Georgeʼs | Bermuda",
    "value": "BDA | Hamilton | L.F. Wade International International Airport | Saint-Georgeʼs | Bermuda"
  },
  {
    "label": "BWN | Bandar Seri Begawan | Brunei International Airport | Brunei Darussalam",
    "value": "BWN | Bandar Seri Begawan | Brunei International Airport | Brunei Darussalam"
  },
  {
    "label": "CBB | Cochabamba | Jorge Wilsterman International Airport | Cochabamba | Bolivia | Plurinational State of",
    "value": "CBB | Cochabamba | Jorge Wilsterman International Airport | Cochabamba | Bolivia | Plurinational State of"
  },
  {
    "label": "LPB | La Paz / El Alto | El Alto International Airport | La-Paz | Bolivia | Plurinational State of",
    "value": "LPB | La Paz / El Alto | El Alto International Airport | La-Paz | Bolivia | Plurinational State of"
  },
  {
    "label": "VVI | Santa Cruz | Viru Viru International Airport | Santa-Cruz | Bolivia | Plurinational State of",
    "value": "VVI | Santa Cruz | Viru Viru International Airport | Santa-Cruz | Bolivia | Plurinational State of"
  },
  {
    "label": "BON | Kralendijk | Flamingo International Airport | Bonaire | Bonaire | Sint Eustatius and Saba",
    "value": "BON | Kralendijk | Flamingo International Airport | Bonaire | Bonaire | Sint Eustatius and Saba"
  },
  {
    "label": "BEL | Belem | Val de Cans/Julio Cezar Ribeiro International Airport | Para | Brazil",
    "value": "BEL | Belem | Val de Cans/Julio Cezar Ribeiro International Airport | Para | Brazil"
  },
  {
    "label": "CNF | Belo Horizonte | Tancredo Neves International Airport | Minas-Gerais | Brazil",
    "value": "CNF | Belo Horizonte | Tancredo Neves International Airport | Minas-Gerais | Brazil"
  },
  {
    "label": "BSB | Brasilia | Presidente Juscelino Kubistschek International Airport | Federal-District | Brazil",
    "value": "BSB | Brasilia | Presidente Juscelino Kubistschek International Airport | Federal-District | Brazil"
  },
  {
    "label": "VCP | Campinas | Viracopos International Airport | Sao-Paulo | Brazil",
    "value": "VCP | Campinas | Viracopos International Airport | Sao-Paulo | Brazil"
  },
  {
    "label": "FLN | Florianopolis | Hercilio Luz International Airport | Santa-Catarina | Brazil",
    "value": "FLN | Florianopolis | Hercilio Luz International Airport | Santa-Catarina | Brazil"
  },
  {
    "label": "FOR | Fortaleza | Pinto Martins International Airport | Ceara | Brazil",
    "value": "FOR | Fortaleza | Pinto Martins International Airport | Ceara | Brazil"
  },
  {
    "label": "IGU | Foz Do Iguacu | Cataratas International Airport | Parana | Brazil",
    "value": "IGU | Foz Do Iguacu | Cataratas International Airport | Parana | Brazil"
  },
  {
    "label": "MAO | Manaus | Eduardo Gomes International Airport | Amazonas | Brazil",
    "value": "MAO | Manaus | Eduardo Gomes International Airport | Amazonas | Brazil"
  },
  {
    "label": "NVT | Navegantes | Ministro Victor Konder International Airport | Santa-Catarina | Brazil",
    "value": "NVT | Navegantes | Ministro Victor Konder International Airport | Santa-Catarina | Brazil"
  },
  {
    "label": "REC | Recife | Guararapes - Gilberto Freyre International Airport | Pernambuco | Brazil",
    "value": "REC | Recife | Guararapes - Gilberto Freyre International Airport | Pernambuco | Brazil"
  },
  {
    "label": "GIG | Rio De Janeiro | Galeao - Antonio Carlos Jobim International Airport | Rio-de-Janeiro | Brazil",
    "value": "GIG | Rio De Janeiro | Galeao - Antonio Carlos Jobim International Airport | Rio-de-Janeiro | Brazil"
  },
  {
    "label": "SSA | Salvador | Deputado Luiz Eduardo Magalhaes International Airport | Bahia | Brazil",
    "value": "SSA | Salvador | Deputado Luiz Eduardo Magalhaes International Airport | Bahia | Brazil"
  },
  {
    "label": "SLZ | Sao Luis | Marechal Cunha Machado International Airport | Maranhao | Brazil",
    "value": "SLZ | Sao Luis | Marechal Cunha Machado International Airport | Maranhao | Brazil"
  },
  {
    "label": "GRU | Sao Paulo | Guarulhos - Governador Andre Franco Montoro International Airport | Sao-Paulo | Brazil",
    "value": "GRU | Sao Paulo | Guarulhos - Governador Andre Franco Montoro International Airport | Sao-Paulo | Brazil"
  },
  {
    "label": "FPO | Freeport | Grand Bahama International Airport | Freeport | Bahamas",
    "value": "FPO | Freeport | Grand Bahama International Airport | Freeport | Bahamas"
  },
  {
    "label": "GGT | George Town | Exuma International Airport | Exuma | Bahamas",
    "value": "GGT | George Town | Exuma International Airport | Exuma | Bahamas"
  },
  {
    "label": "MHH | Marsh Harbour | Marsh Harbour International Airport | Bahamas",
    "value": "MHH | Marsh Harbour | Marsh Harbour International Airport | Bahamas"
  },
  {
    "label": "NAS | Nassau | Lynden Pindling International Airport | New-Providence | Bahamas",
    "value": "NAS | Nassau | Lynden Pindling International Airport | New-Providence | Bahamas"
  },
  {
    "label": "GBE | Gaborone | Sir Seretse Khama International Airport | South-East | Botswana",
    "value": "GBE | Gaborone | Sir Seretse Khama International Airport | South-East | Botswana"
  },
  {
    "label": "MSQ | Minsk | Minsk International Airport | Minsk | Belarus",
    "value": "MSQ | Minsk | Minsk International Airport | Minsk | Belarus"
  },
  {
    "label": "BZE | Belize City | Philip S. W. Goldson International Airport | Belize | Belize",
    "value": "BZE | Belize City | Philip S. W. Goldson International Airport | Belize | Belize"
  },
  {
    "label": "YYC | Calgary | Calgary International Airport | Alberta | Canada",
    "value": "YYC | Calgary | Calgary International Airport | Alberta | Canada"
  },
  {
    "label": "YQX | Gander | Gander International Airport | Newfoundland and Labrador | Canada",
    "value": "YQX | Gander | Gander International Airport | Newfoundland and Labrador | Canada"
  },
  {
    "label": "YHZ | Halifax | Halifax / Stanfield International Airport | Nova Scotia | Canada",
    "value": "YHZ | Halifax | Halifax / Stanfield International Airport | Nova Scotia | Canada"
  },
  {
    "label": "YHM | Hamilton | John C. Munro Hamilton International Airport | Ontario | Canada",
    "value": "YHM | Hamilton | John C. Munro Hamilton International Airport | Ontario | Canada"
  },
  {
    "label": "YQM | Moncton | Greater Moncton International Airport | New Brunswick | Canada",
    "value": "YQM | Moncton | Greater Moncton International Airport | New Brunswick | Canada"
  },
  {
    "label": "YUL | Montreal | Montreal / Pierre Elliott Trudeau International Airport | Quebec | Canada",
    "value": "YUL | Montreal | Montreal / Pierre Elliott Trudeau International Airport | Quebec | Canada"
  },
  {
    "label": "YMX | Montreal | Montreal International (Mirabel) Airport | Quebec | Canada",
    "value": "YMX | Montreal | Montreal International (Mirabel) Airport | Quebec | Canada"
  },
  {
    "label": "YOW | Ottawa | Ottawa Macdonald-Cartier International Airport | Ontario | Canada",
    "value": "YOW | Ottawa | Ottawa Macdonald-Cartier International Airport | Ontario | Canada"
  },
  {
    "label": "YQB | Quebec | Quebec Jean Lesage International Airport | Quebec | Canada",
    "value": "YQB | Quebec | Quebec Jean Lesage International Airport | Quebec | Canada"
  },
  {
    "label": "YQR | Regina | Regina International Airport | Saskatchewan | Canada",
    "value": "YQR | Regina | Regina International Airport | Saskatchewan | Canada"
  },
  {
    "label": "YTM | Riviere Rouge | La Macaza / Mont-Tremblant International Inc Airport | Quebec | Canada",
    "value": "YTM | Riviere Rouge | La Macaza / Mont-Tremblant International Inc Airport | Quebec | Canada"
  },
  {
    "label": "YXE | Saskatoon | Saskatoon John G. Diefenbaker International Airport | Saskatchewan | Canada",
    "value": "YXE | Saskatoon | Saskatoon John G. Diefenbaker International Airport | Saskatchewan | Canada"
  },
  {
    "label": "YYT | St. John's | St. John's International Airport | Newfoundland-and-Labrador | Canada",
    "value": "YYT | St. John's | St. John's International Airport | Newfoundland-and-Labrador | Canada"
  },
  {
    "label": "YYZ | Toronto | Lester B. Pearson International Airport | Ontario | Canada",
    "value": "YYZ | Toronto | Lester B. Pearson International Airport | Ontario | Canada"
  },
  {
    "label": "YVR | Vancouver | Vancouver International Airport | British Columbia | Canada",
    "value": "YVR | Vancouver | Vancouver International Airport | British Columbia | Canada"
  },
  {
    "label": "YYJ | Victoria | Victoria International Airport | British-Columbia | Canada",
    "value": "YYJ | Victoria | Victoria International Airport | British-Columbia | Canada"
  },
  {
    "label": "YXY | Whitehorse | Whitehorse / Erik Nielsen International Airport | Yukon | Canada",
    "value": "YXY | Whitehorse | Whitehorse / Erik Nielsen International Airport | Yukon | Canada"
  },
  {
    "label": "YWG | Winnipeg | Winnipeg / James Armstrong Richardson International Airport | Manitoba | Canada",
    "value": "YWG | Winnipeg | Winnipeg / James Armstrong Richardson International Airport | Manitoba | Canada"
  },
  {
    "label": "GOM | Goma | Goma International Airport | Congo | the Democratic Republic of the",
    "value": "GOM | Goma | Goma International Airport | Congo | the Democratic Republic of the"
  },
  {
    "label": "FIH | Kinshasa | Ndjili International Airport | Congo | the Democratic Republic of the",
    "value": "FIH | Kinshasa | Ndjili International Airport | Congo | the Democratic Republic of the"
  },
  {
    "label": "FKI | Kisangani | Bangoka International Airport | Tshopo | Congo | the Democratic Republic of the",
    "value": "FKI | Kisangani | Bangoka International Airport | Tshopo | Congo | the Democratic Republic of the"
  },
  {
    "label": "FBM | Lubumbashi | Lubumbashi International Airport | Congo | the Democratic Republic of the",
    "value": "FBM | Lubumbashi | Lubumbashi International Airport | Congo | the Democratic Republic of the"
  },
  {
    "label": "BGF | Bangui | Bangui M'Poko International Airport | Ombella-M'Poko | Central African Republic",
    "value": "BGF | Bangui | Bangui M'Poko International Airport | Ombella-M'Poko | Central African Republic"
  },
  {
    "label": "GVA | Geneva | Geneva Cointrin International Airport | Geneva | Switzerland",
    "value": "GVA | Geneva | Geneva Cointrin International Airport | Geneva | Switzerland"
  },
  {
    "label": "RAR | Avarua | Rarotonga International Airport | Cook Islands",
    "value": "RAR | Avarua | Rarotonga International Airport | Cook Islands"
  },
  {
    "label": "SCL | Santiago | Comodoro Arturo Merino Benitez International Airport | Santiago-Metropolitan | Chile",
    "value": "SCL | Santiago | Comodoro Arturo Merino Benitez International Airport | Santiago-Metropolitan | Chile"
  },
  {
    "label": "DLA | Douala | Douala International Airport | Littoral | Cameroon",
    "value": "DLA | Douala | Douala International Airport | Littoral | Cameroon"
  },
  {
    "label": "GOU | Garoua | Garoua International Airport | North | Cameroon",
    "value": "GOU | Garoua | Garoua International Airport | North | Cameroon"
  },
  {
    "label": "NSI | Yaounde | Yaounde Nsimalen International Airport | Centre | Cameroon",
    "value": "NSI | Yaounde | Yaounde Nsimalen International Airport | Centre | Cameroon"
  },
  {
    "label": "PEK | Beijing | Beijing Capital International Airport | Beijing | China",
    "value": "PEK | Beijing | Beijing Capital International Airport | Beijing | China"
  },
  {
    "label": "CTU | Chengdu | Chengdu Shuangliu International Airport | Sichuan | China",
    "value": "CTU | Chengdu | Chengdu Shuangliu International Airport | Sichuan | China"
  },
  {
    "label": "CKG | Chongqing | Chongqing Jiangbei International Airport | Chongqing | China",
    "value": "CKG | Chongqing | Chongqing Jiangbei International Airport | Chongqing | China"
  },
  {
    "label": "FOC | Fuzhou | Fuzhou Changle International Airport | Fujian | China",
    "value": "FOC | Fuzhou | Fuzhou Changle International Airport | Fujian | China"
  },
  {
    "label": "CAN | Guangzhou | Guangzhou Baiyun International Airport | Guangdong | China",
    "value": "CAN | Guangzhou | Guangzhou Baiyun International Airport | Guangdong | China"
  },
  {
    "label": "KWL | Guilin City | Guilin Liangjiang International Airport | Guangxi | China",
    "value": "KWL | Guilin City | Guilin Liangjiang International Airport | Guangxi | China"
  },
  {
    "label": "HAK | Haikou | Haikou Meilan International Airport | Hainan | China",
    "value": "HAK | Haikou | Haikou Meilan International Airport | Hainan | China"
  },
  {
    "label": "HGH | Hangzhou | Hangzhou Xiaoshan International Airport | Zhejiang | China",
    "value": "HGH | Hangzhou | Hangzhou Xiaoshan International Airport | Zhejiang | China"
  },
  {
    "label": "HFE | Hefei | Hefei Luogang International Airport | Anhui | China",
    "value": "HFE | Hefei | Hefei Luogang International Airport | Anhui | China"
  },
  {
    "label": "HET | Hohhot | Baita International Airport | Inner-Mongolia | China",
    "value": "HET | Hohhot | Baita International Airport | Inner-Mongolia | China"
  },
  {
    "label": "TXN | Huangshan | Tunxi International Airport | Anhui | China",
    "value": "TXN | Huangshan | Tunxi International Airport | Anhui | China"
  },
  {
    "label": "KMG | Kunming | Kunming Wujiaba International Airport | Yunnan | China",
    "value": "KMG | Kunming | Kunming Wujiaba International Airport | Yunnan | China"
  },
  {
    "label": "MDG | Mudanjiang | Mudanjiang Hailang International Airport | Heilongjiang | China",
    "value": "MDG | Mudanjiang | Mudanjiang Hailang International Airport | Heilongjiang | China"
  },
  {
    "label": "KHN | Nanchang | Nanchang Changbei International Airport | Jiangxi | China",
    "value": "KHN | Nanchang | Nanchang Changbei International Airport | Jiangxi | China"
  },
  {
    "label": "NGB | Ningbo | Ningbo Lishe International Airport | Zhejiang | China",
    "value": "NGB | Ningbo | Ningbo Lishe International Airport | Zhejiang | China"
  },
  {
    "label": "SYX | Sanya | Sanya Phoenix International Airport | Hainan | China",
    "value": "SYX | Sanya | Sanya Phoenix International Airport | Hainan | China"
  },
  {
    "label": "SHA | Shanghai | Shanghai Hongqiao International Airport | Shanghai | China",
    "value": "SHA | Shanghai | Shanghai Hongqiao International Airport | Shanghai | China"
  },
  {
    "label": "PVG | Shanghai | Shanghai Pudong International Airport | Shanghai | China",
    "value": "PVG | Shanghai | Shanghai Pudong International Airport | Shanghai | China"
  },
  {
    "label": "SZX | Shenzhen | Shenzhen Bao'an International Airport | Guangdong | China",
    "value": "SZX | Shenzhen | Shenzhen Bao'an International Airport | Guangdong | China"
  },
  {
    "label": "SJW | Shijiazhuang | Shijiazhuang Daguocun International Airport | Hebei | China",
    "value": "SJW | Shijiazhuang | Shijiazhuang Daguocun International Airport | Hebei | China"
  },
  {
    "label": "TSN | Tianjin | Tianjin Binhai International Airport | Tianjin | China",
    "value": "TSN | Tianjin | Tianjin Binhai International Airport | Tianjin | China"
  },
  {
    "label": "URC | Urumqi | Urumqi Diwopu International Airport | Xinjiang | China",
    "value": "URC | Urumqi | Urumqi Diwopu International Airport | Xinjiang | China"
  },
  {
    "label": "WUH | Wuhan | Wuhan Tianhe International Airport | Hubei | China",
    "value": "WUH | Wuhan | Wuhan Tianhe International Airport | Hubei | China"
  },
  {
    "label": "WUX | Wuxi | Sunan Shuofang International Airport | Jiangsu | China",
    "value": "WUX | Wuxi | Sunan Shuofang International Airport | Jiangsu | China"
  },
  {
    "label": "XMN | Xiamen | Xiamen Gaoqi International Airport | Fujian | China",
    "value": "XMN | Xiamen | Xiamen Gaoqi International Airport | Fujian | China"
  },
  {
    "label": "XIY | Xianyang | Xi'an Xianyang International Airport | Shaanxi | China",
    "value": "XIY | Xianyang | Xi'an Xianyang International Airport | Shaanxi | China"
  },
  {
    "label": "BAQ | Barranquilla | Ernesto Cortissoz International Airport | Atlantico | Colombia",
    "value": "BAQ | Barranquilla | Ernesto Cortissoz International Airport | Atlantico | Colombia"
  },
  {
    "label": "BOG | Bogota | El Dorado International Airport | Bogota-D-C- | Colombia",
    "value": "BOG | Bogota | El Dorado International Airport | Bogota-D-C- | Colombia"
  },
  {
    "label": "CLO | Cali | Alfonso Bonilla Aragon International Airport | Valle-del-Cauca | Colombia",
    "value": "CLO | Cali | Alfonso Bonilla Aragon International Airport | Valle-del-Cauca | Colombia"
  },
  {
    "label": "CTG | Cartagena | Rafael Nunez International Airport | Bolivar | Colombia",
    "value": "CTG | Cartagena | Rafael Nunez International Airport | Bolivar | Colombia"
  },
  {
    "label": "CUC | Cucuta | Camilo Daza International Airport | Norte-de-Santander | Colombia",
    "value": "CUC | Cucuta | Camilo Daza International Airport | Norte-de-Santander | Colombia"
  },
  {
    "label": "LET | Leticia | Alfredo Vasquez Cobo International Airport | Amazonas | Colombia",
    "value": "LET | Leticia | Alfredo Vasquez Cobo International Airport | Amazonas | Colombia"
  },
  {
    "label": "PEI | Pereira | Matecana International Airport | Risaralda | Colombia",
    "value": "PEI | Pereira | Matecana International Airport | Risaralda | Colombia"
  },
  {
    "label": "MDE | Rionegro | Jose Maria Cordova International Airport | Antioquia | Colombia",
    "value": "MDE | Rionegro | Jose Maria Cordova International Airport | Antioquia | Colombia"
  },
  {
    "label": "ADZ | San Andres | Gustavo Rojas Pinilla International Airport | San-Andres-y-Providencia | Colombia",
    "value": "ADZ | San Andres | Gustavo Rojas Pinilla International Airport | San-Andres-y-Providencia | Colombia"
  },
  {
    "label": "SMR | Santa Marta | Simon Bolivar International Airport | Magdalena | Colombia",
    "value": "SMR | Santa Marta | Simon Bolivar International Airport | Magdalena | Colombia"
  },
  {
    "label": "LIR | Liberia | Daniel Oduber Quiros International Airport | Guanacaste | Costa Rica",
    "value": "LIR | Liberia | Daniel Oduber Quiros International Airport | Guanacaste | Costa Rica"
  },
  {
    "label": "SJO | San Jose | Juan Santamaria International Airport | Alajuela | Costa Rica",
    "value": "SJO | San Jose | Juan Santamaria International Airport | Alajuela | Costa Rica"
  },
  {
    "label": "SYQ | San Jose | Tobias Bolanos International Airport | San-Jose | Costa Rica",
    "value": "SYQ | San Jose | Tobias Bolanos International Airport | San-Jose | Costa Rica"
  },
  {
    "label": "CMW | Camaguey | Ignacio Agramonte International Airport | Camagueey | Cuba",
    "value": "CMW | Camaguey | Ignacio Agramonte International Airport | Camagueey | Cuba"
  },
  {
    "label": "HAV | Havana | Jose Marti International Airport | La-Habana | Cuba",
    "value": "HAV | Havana | Jose Marti International Airport | La-Habana | Cuba"
  },
  {
    "label": "HOG | Holguin | Frank Pais International Airport | Holguin | Cuba",
    "value": "HOG | Holguin | Frank Pais International Airport | Holguin | Cuba"
  },
  {
    "label": "SCU | Santiago | Antonio Maceo International Airport | Santiago-de-Cuba | Cuba",
    "value": "SCU | Santiago | Antonio Maceo International Airport | Santiago-de-Cuba | Cuba"
  },
  {
    "label": "VRA | Varadero | Juan Gualberto Gomez International Airport | Matanzas | Cuba",
    "value": "VRA | Varadero | Juan Gualberto Gomez International Airport | Matanzas | Cuba"
  },
  {
    "label": "SID | Espargos | Amilcar Cabral International Airport | Sal | Cape Verde",
    "value": "SID | Espargos | Amilcar Cabral International Airport | Sal | Cape Verde"
  },
  {
    "label": "RAI | Praia | Praia International Airport | Praia | Cape Verde",
    "value": "RAI | Praia | Praia International Airport | Praia | Cape Verde"
  },
  {
    "label": "CUR | Willemstad | Hato International Airport | CuraÃ§ao",
    "value": "CUR | Willemstad | Hato International Airport | CuraÃ§ao"
  },
  {
    "label": "LCA | Larnarca | Larnaca International Airport | Larnaka | Cyprus",
    "value": "LCA | Larnarca | Larnaca International Airport | Larnaka | Cyprus"
  },
  {
    "label": "ECN | Nicosia | Ercan International Airport | Nicosia | Cyprus",
    "value": "ECN | Nicosia | Ercan International Airport | Nicosia | Cyprus"
  },
  {
    "label": "PFO | Paphos | Paphos International Airport | Pafos | Cyprus",
    "value": "PFO | Paphos | Paphos International Airport | Pafos | Cyprus"
  },
  {
    "label": "KLV | Karlovy Vary | Karlovy Vary International Airport | Karlovarsky | Czech Republic",
    "value": "KLV | Karlovy Vary | Karlovy Vary International Airport | Karlovarsky | Czech Republic"
  },
  {
    "label": "PRG | Prague | Ruzyne International Airport | Praha | Czech Republic",
    "value": "PRG | Prague | Ruzyne International Airport | Praha | Czech Republic"
  },
  {
    "label": "SXF | Berlin | Berlin-Schonefeld International Airport | Brandenburg | Germany",
    "value": "SXF | Berlin | Berlin-Schonefeld International Airport | Brandenburg | Germany"
  },
  {
    "label": "TXL | Berlin | Berlin-Tegel International Airport | Berlin | Germany",
    "value": "TXL | Berlin | Berlin-Tegel International Airport | Berlin | Germany"
  },
  {
    "label": "DUS | Dusseldorf | Dusseldorf International Airport | North-Rhine-Westphalia | Germany",
    "value": "DUS | Dusseldorf | Dusseldorf International Airport | North-Rhine-Westphalia | Germany"
  },
  {
    "label": "FRA | Frankfurt-am-Main | Frankfurt am Main International Airport | Hesse | Germany",
    "value": "FRA | Frankfurt-am-Main | Frankfurt am Main International Airport | Hesse | Germany"
  },
  {
    "label": "BRX | Barahona | Maria Montez International Airport | Barahona | Dominican Republic",
    "value": "BRX | Barahona | Maria Montez International Airport | Barahona | Dominican Republic"
  },
  {
    "label": "JBQ | La Isabela | La Isabela International Airport | Santo-Domingo | Dominican Republic",
    "value": "JBQ | La Isabela | La Isabela International Airport | Santo-Domingo | Dominican Republic"
  },
  {
    "label": "LRM | La Romana | Casa De Campo International Airport | La-Romana | Dominican Republic",
    "value": "LRM | La Romana | Casa De Campo International Airport | La-Romana | Dominican Republic"
  },
  {
    "label": "POP | Puerto Plata | Gregorio Luperon International Airport | Puerto-Plata | Dominican Republic",
    "value": "POP | Puerto Plata | Gregorio Luperon International Airport | Puerto-Plata | Dominican Republic"
  },
  {
    "label": "PUJ | Punta Cana | Punta Cana International Airport | La-Altagracia | Dominican Republic",
    "value": "PUJ | Punta Cana | Punta Cana International Airport | La-Altagracia | Dominican Republic"
  },
  {
    "label": "AZS | Samana | Samana El Catey International Airport | Maria-Trinidad-Sanchez | Dominican Republic",
    "value": "AZS | Samana | Samana El Catey International Airport | Maria-Trinidad-Sanchez | Dominican Republic"
  },
  {
    "label": "SDQ | Santo Domingo | Las Americas International Airport | Nacional | Dominican Republic",
    "value": "SDQ | Santo Domingo | Las Americas International Airport | Nacional | Dominican Republic"
  },
  {
    "label": "CZL | Constantine | Mohamed Boudiaf International Airport | Constantine | Algeria",
    "value": "CZL | Constantine | Mohamed Boudiaf International Airport | Constantine | Algeria"
  },
  {
    "label": "GYE | Guayaquil | Simon Bolivar International Airport | Guayas | Ecuador",
    "value": "GYE | Guayaquil | Simon Bolivar International Airport | Guayas | Ecuador"
  },
  {
    "label": "LTX | Latacunga | Cotopaxi International Airport | Cotopaxi | Ecuador",
    "value": "LTX | Latacunga | Cotopaxi International Airport | Cotopaxi | Ecuador"
  },
  {
    "label": "MEC | Manta | Eloy Alfaro International Airport | Manabi | Ecuador",
    "value": "MEC | Manta | Eloy Alfaro International Airport | Manabi | Ecuador"
  },
  {
    "label": "UIO | Quito | Nuevo Aeropuerto Internacional Mariscal Sucre | Pichincha | Ecuador",
    "value": "UIO | Quito | Nuevo Aeropuerto Internacional Mariscal Sucre | Pichincha | Ecuador"
  },
  {
    "label": "HBE | Alexandria | Borg El Arab International Airport | Alexandria | Egypt",
    "value": "HBE | Alexandria | Borg El Arab International Airport | Alexandria | Egypt"
  },
  {
    "label": "ATZ | Assiut | Assiut International Airport | Asyut | Egypt",
    "value": "ATZ | Assiut | Assiut International Airport | Asyut | Egypt"
  },
  {
    "label": "ASW | Aswan | Aswan International Airport | Aswan | Egypt",
    "value": "ASW | Aswan | Aswan International Airport | Aswan | Egypt"
  },
  {
    "label": "CAI | Cairo | Cairo International Airport | Cairo | Egypt",
    "value": "CAI | Cairo | Cairo International Airport | Cairo | Egypt"
  },
  {
    "label": "DBB | El Alamein | El Alamein International Airport | Matruh | Egypt",
    "value": "DBB | El Alamein | El Alamein International Airport | Matruh | Egypt"
  },
  {
    "label": "AAC | El Arish | El Arish International Airport | North-Sinai | Egypt",
    "value": "AAC | El Arish | El Arish International Airport | North-Sinai | Egypt"
  },
  {
    "label": "SPX | Giza | Sphinx International Airport | Giza | Egypt",
    "value": "SPX | Giza | Sphinx International Airport | Giza | Egypt"
  },
  {
    "label": "HRG | Hurghada | Hurghada International Airport | Red-Sea | Egypt",
    "value": "HRG | Hurghada | Hurghada International Airport | Red-Sea | Egypt"
  },
  {
    "label": "LXR | Luxor | Luxor International Airport | Qena | Egypt",
    "value": "LXR | Luxor | Luxor International Airport | Qena | Egypt"
  },
  {
    "label": "RMF | Marsa Alam | Marsa Alam International Airport | Red-Sea | Egypt",
    "value": "RMF | Marsa Alam | Marsa Alam International Airport | Red-Sea | Egypt"
  },
  {
    "label": "SSH | Sharm el-Sheikh | Sharm El Sheikh International Airport | South-Sinai | Egypt",
    "value": "SSH | Sharm el-Sheikh | Sharm El Sheikh International Airport | South-Sinai | Egypt"
  },
  {
    "label": "HMB | Sohag | Sohag International Airport | New-Valley | Egypt",
    "value": "HMB | Sohag | Sohag International Airport | New-Valley | Egypt"
  },
  {
    "label": "TCP | Taba | Taba International Airport | South-Sinai | Egypt",
    "value": "TCP | Taba | Taba International Airport | South-Sinai | Egypt"
  },
  {
    "label": "ASA | Asab | Assab International Airport | Eritrea",
    "value": "ASA | Asab | Assab International Airport | Eritrea"
  },
  {
    "label": "ASM | Asmara | Asmara International Airport | Maekel | Eritrea",
    "value": "ASM | Asmara | Asmara International Airport | Maekel | Eritrea"
  },
  {
    "label": "MSW | Massawa | Massawa International Airport | Northern-Red-Sea | Eritrea",
    "value": "MSW | Massawa | Massawa International Airport | Northern-Red-Sea | Eritrea"
  },
  {
    "label": "ALC | Alicante | Alicante International Airport | Valencia | Spain",
    "value": "ALC | Alicante | Alicante International Airport | Valencia | Spain"
  },
  {
    "label": "LEI | Almeria | Almeria International Airport | Andalusia | Spain",
    "value": "LEI | Almeria | Almeria International Airport | Andalusia | Spain"
  },
  {
    "label": "BCN | Barcelona | Barcelona International Airport | Catalonia | Spain",
    "value": "BCN | Barcelona | Barcelona International Airport | Catalonia | Spain"
  },
  {
    "label": "RMU | Corvera | Región de Murcia International Airport | Corvera | Spain",
    "value": "RMU | Corvera | Región de Murcia International Airport | Corvera | Spain"
  },
  {
    "label": "MAD | Madrid | Madrid Barajas International Airport | Madrid | Spain",
    "value": "MAD | Madrid | Madrid Barajas International Airport | Madrid | Spain"
  },
  {
    "label": "ADD | Addis Ababa | Bole International Airport | Addis-Ababa | Ethiopia",
    "value": "ADD | Addis Ababa | Bole International Airport | Addis-Ababa | Ethiopia"
  },
  {
    "label": "DIR | Dire Dawa | Aba Tenna Dejazmach Yilma International Airport | Dire-Dawa | Ethiopia",
    "value": "DIR | Dire Dawa | Aba Tenna Dejazmach Yilma International Airport | Dire-Dawa | Ethiopia"
  },
  {
    "label": "NAN | Nadi | Nadi International Airport | Western | Fiji",
    "value": "NAN | Nadi | Nadi International Airport | Western | Fiji"
  },
  {
    "label": "SUV | Nausori | Nausori International Airport | Central | Fiji",
    "value": "SUV | Nausori | Nausori International Airport | Central | Fiji"
  },
  {
    "label": "KSA | Okat | Kosrae International Airport | Kosrae | Micronesia | Federated States of",
    "value": "KSA | Okat | Kosrae International Airport | Kosrae | Micronesia | Federated States of"
  },
  {
    "label": "PNI | Pohnpei Island | Pohnpei International Airport | Pohnpei | Micronesia | Federated States of",
    "value": "PNI | Pohnpei Island | Pohnpei International Airport | Pohnpei | Micronesia | Federated States of"
  },
  {
    "label": "TKK | Weno Island | Chuuk International Airport | Chuuk | Micronesia | Federated States of",
    "value": "TKK | Weno Island | Chuuk International Airport | Chuuk | Micronesia | Federated States of"
  },
  {
    "label": "YAP | Yap Island | Yap International Airport | Yap | Micronesia | Federated States of",
    "value": "YAP | Yap Island | Yap International Airport | Yap | Micronesia | Federated States of"
  },
  {
    "label": "CDG | Paris | Charles de Gaulle International Airport | Ile-de-France | France",
    "value": "CDG | Paris | Charles de Gaulle International Airport | Ile-de-France | France"
  },
  {
    "label": "MVB | Franceville | M'Vengue El Hadj Omar Bongo Ondimba International Airport | Haut-Ogooue | Gabon",
    "value": "MVB | Franceville | M'Vengue El Hadj Omar Bongo Ondimba International Airport | Haut-Ogooue | Gabon"
  },
  {
    "label": "BFS | Belfast | Belfast International Airport | Northern-Ireland | United Kingdom",
    "value": "BFS | Belfast | Belfast International Airport | Northern-Ireland | United Kingdom"
  },
  {
    "label": "BHX | Birmingham | Birmingham International Airport | England | United Kingdom",
    "value": "BHX | Birmingham | Birmingham International Airport | England | United Kingdom"
  },
  {
    "label": "BLK | Blackpool | Blackpool International Airport | England | United Kingdom",
    "value": "BLK | Blackpool | Blackpool International Airport | England | United Kingdom"
  },
  {
    "label": "BRS | Bristol | Bristol International Airport | England | United Kingdom",
    "value": "BRS | Bristol | Bristol International Airport | England | United Kingdom"
  },
  {
    "label": "CWL | Cardiff | Cardiff International Airport | Wales | United Kingdom",
    "value": "CWL | Cardiff | Cardiff International Airport | Wales | United Kingdom"
  },
  {
    "label": "EXT | Exeter | Exeter International Airport | England | United Kingdom",
    "value": "EXT | Exeter | Exeter International Airport | England | United Kingdom"
  },
  {
    "label": "NWI | Norwich | Norwich International Airport | England | United Kingdom",
    "value": "NWI | Norwich | Norwich International Airport | England | United Kingdom"
  },
  {
    "label": "GND | Saint George's | Point Salines International Airport | Saint-George | Grenada",
    "value": "GND | Saint George's | Point Salines International Airport | Saint-George | Grenada"
  },
  {
    "label": "BUS | Batumi | Batumi International Airport | Ajaria | Georgia",
    "value": "BUS | Batumi | Batumi International Airport | Ajaria | Georgia"
  },
  {
    "label": "TBS | Tbilisi | Tbilisi International Airport | Georgia",
    "value": "TBS | Tbilisi | Tbilisi International Airport | Georgia"
  },
  {
    "label": "ACC | Accra | Kotoka International Airport | Ghana",
    "value": "ACC | Accra | Kotoka International Airport | Ghana"
  },
  {
    "label": "BJL | Banjul | Banjul International Airport | Western | Gambia",
    "value": "BJL | Banjul | Banjul International Airport | Western | Gambia"
  },
  {
    "label": "ATH | Athens | Eleftherios Venizelos International Airport | Attica | Greece",
    "value": "ATH | Athens | Eleftherios Venizelos International Airport | Attica | Greece"
  },
  {
    "label": "HER | Heraklion | Heraklion International Nikos Kazantzakis Airport | Crete | Greece",
    "value": "HER | Heraklion | Heraklion International Nikos Kazantzakis Airport | Crete | Greece"
  },
  {
    "label": "KVA | Kavala | Alexander the Great International Airport | East-Macedonia-and-Thrace | Greece",
    "value": "KVA | Kavala | Alexander the Great International Airport | East-Macedonia-and-Thrace | Greece"
  },
  {
    "label": "CFU | Kerkyra Island | Ioannis Kapodistrias International Airport | Ionian-Islands | Greece",
    "value": "CFU | Kerkyra Island | Ioannis Kapodistrias International Airport | Ionian-Islands | Greece"
  },
  {
    "label": "MJT | Mytilene | Mytilene International Airport | North-Aegean | Greece",
    "value": "MJT | Mytilene | Mytilene International Airport | North-Aegean | Greece"
  },
  {
    "label": "CHQ | Souda | Chania International Airport | Crete | Greece",
    "value": "CHQ | Souda | Chania International Airport | Crete | Greece"
  },
  {
    "label": "SKG | Thessaloniki | Thessaloniki Macedonia International Airport | Central-Macedonia | Greece",
    "value": "SKG | Thessaloniki | Thessaloniki Macedonia International Airport | Central-Macedonia | Greece"
  },
  {
    "label": "FRS | San Benito | Mundo Maya International Airport | Peten | Guatemala",
    "value": "FRS | San Benito | Mundo Maya International Airport | Peten | Guatemala"
  },
  {
    "label": "GUM | Hagatna | Antonio B. Won Pat International Airport | Barrigada | Guam",
    "value": "GUM | Hagatna | Antonio B. Won Pat International Airport | Barrigada | Guam"
  },
  {
    "label": "OXB | Bissau | Osvaldo Vieira International Airport | Guinea-Bissau",
    "value": "OXB | Bissau | Osvaldo Vieira International Airport | Guinea-Bissau"
  },
  {
    "label": "GEO | Georgetown | Cheddi Jagan International Airport | Demerara-Mahaica | Guyana",
    "value": "GEO | Georgetown | Cheddi Jagan International Airport | Demerara-Mahaica | Guyana"
  },
  {
    "label": "KIA | Kaieteur Falls | Kaieteur International Airport | Potaro-Siparuni | Guyana",
    "value": "KIA | Kaieteur Falls | Kaieteur International Airport | Potaro-Siparuni | Guyana"
  },
  {
    "label": "HKG | Hong Kong | Chek Lap Kok International Airport | Hong Kong",
    "value": "HKG | Hong Kong | Chek Lap Kok International Airport | Hong Kong"
  },
  {
    "label": "LCE | La Ceiba | Goloson International Airport | Atlantida | Honduras",
    "value": "LCE | La Ceiba | Goloson International Airport | Atlantida | Honduras"
  },
  {
    "label": "SAP | La Mesa | Ramon Villeda Morales International Airport | Cortes | Honduras",
    "value": "SAP | La Mesa | Ramon Villeda Morales International Airport | Cortes | Honduras"
  },
  {
    "label": "RTB | Roatan Island | Juan Manuel Galvez International Airport | Bay-Islands | Honduras",
    "value": "RTB | Roatan Island | Juan Manuel Galvez International Airport | Bay-Islands | Honduras"
  },
  {
    "label": "TGU | Tegucigalpa | Toncontin International Airport | Francisco-Morazan | Honduras",
    "value": "TGU | Tegucigalpa | Toncontin International Airport | Francisco-Morazan | Honduras"
  },
  {
    "label": "CAP | Cap Haitien | Cap Haitien International Airport | Nord | Haiti",
    "value": "CAP | Cap Haitien | Cap Haitien International Airport | Nord | Haiti"
  },
  {
    "label": "PAP | Port-au-Prince | Toussaint Louverture International Airport | Ouest | Haiti",
    "value": "PAP | Port-au-Prince | Toussaint Louverture International Airport | Ouest | Haiti"
  },
  {
    "label": "BUD | Budapest | Budapest Listz Ferenc international Airport | Budapest | Hungary",
    "value": "BUD | Budapest | Budapest Listz Ferenc international Airport | Budapest | Hungary"
  },
  {
    "label": "SOB | Sarmellek | Sarmellek International Airport | Zala | Hungary",
    "value": "SOB | Sarmellek | Sarmellek International Airport | Zala | Hungary"
  },
  {
    "label": "BPN | Balikpapan-Borneo Island | Sepinggan International Airport | East-Kalimantan | Indonesia",
    "value": "BPN | Balikpapan-Borneo Island | Sepinggan International Airport | East-Kalimantan | Indonesia"
  },
  {
    "label": "BDO | Bandung-Java Island | Husein Sastranegara International Airport | West-Java | Indonesia",
    "value": "BDO | Bandung-Java Island | Husein Sastranegara International Airport | West-Java | Indonesia"
  },
  {
    "label": "DPS | Denpasar-Bali Island | Ngurah Rai (Bali) International Airport | Bali | Indonesia",
    "value": "DPS | Denpasar-Bali Island | Ngurah Rai (Bali) International Airport | Bali | Indonesia"
  },
  {
    "label": "HLP | Jakarta | Halim Perdanakusuma International Airport | Jakarta | Indonesia",
    "value": "HLP | Jakarta | Halim Perdanakusuma International Airport | Jakarta | Indonesia"
  },
  {
    "label": "CGK | Jakarta | Soekarno-Hatta International Airport | Indonesia",
    "value": "CGK | Jakarta | Soekarno-Hatta International Airport | Indonesia"
  },
  {
    "label": "LOP | Mataram | Bandara International Lombok Airport | West-Nusa-Tenggara | Indonesia",
    "value": "LOP | Mataram | Bandara International Lombok Airport | West-Nusa-Tenggara | Indonesia"
  },
  {
    "label": "KNO | Medan-Sumatra Island | Polonia International Airport | Indonesia",
    "value": "KNO | Medan-Sumatra Island | Polonia International Airport | Indonesia"
  },
  {
    "label": "UPG | Ujung Pandang-Celebes Island | Hasanuddin International Airport | South-Sulawesi | Indonesia",
    "value": "UPG | Ujung Pandang-Celebes Island | Hasanuddin International Airport | South-Sulawesi | Indonesia"
  },
  {
    "label": "JOG | Yogyakarta-Java Island | Adi Sutjipto International Airport | Yogyakarta | Indonesia",
    "value": "JOG | Yogyakarta-Java Island | Adi Sutjipto International Airport | Yogyakarta | Indonesia"
  },
  {
    "label": "VDA | Eilat | Ovda International Airport | Southern-District | Israel",
    "value": "VDA | Eilat | Ovda International Airport | Southern-District | Israel"
  },
  {
    "label": "HFA | Haifa | Haifa International Airport | Haifa | Israel",
    "value": "HFA | Haifa | Haifa International Airport | Haifa | Israel"
  },
  {
    "label": "TLV | Tel Aviv | Ben Gurion International Airport | Central-District | Israel",
    "value": "TLV | Tel Aviv | Ben Gurion International Airport | Central-District | Israel"
  }
];
const professionOptions = [{
  label: 'Engineer', value: 'Engineer'
},
{
  label: 'Doctor', value: 'Doctor'
},
{
  label: 'Defense', value: 'Defense'
},
{
  label: 'Student', value: 'Student'
},
{
  label: 'Entrepreneur', value: 'Entrepreneur'
},
{
  label: 'Other', value: 'Other'
}]
const formReducer = (state, event) => {
  if (event.reset) {
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return {
      journeyType: '2',
      page: 0,
      departureDate: new Date(),
      returnDate: tomorrow,
      isFlexible: false,
      contactType: 'whatsapp',
    }
  }
  return {
    ...state,
    [event.name]: event.value
  }
}

const App = () => {

  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const [formData, setFormData] = useReducer(formReducer, {
    journeyType: '2',
    page: 0,
    departureDate: new Date(),
    returnDate: tomorrow,
    isFlexible: false,
    contactType: 'whatsapp',
  });
  const [submitStatus, setSubmitStatus] = useState('pending');

  const handleSubmit = event => {
    console.log('Submit pressed');
    if (!formData.depAirport || !formData.arrAirport) {
      alert('Please fill required fields')
    } else {
      if (formData.depAirport === formData.arrAirport) {
        alert("Departure and Arrival Airports can't be same");
      } else {
        let currentDate = new Date()
        let nowDate = currentDate.toISOString().substring(0, 10)
        let depDate = formData.departureDate.toISOString().substring(0, 10)
        if (depDate < nowDate) {
          alert('Past dates are not allowed')
        } else {
          if (formData.journeyType === '2' && formData.departureDate > formData.returnDate) {
            alert("Journey Date can't be after Return Date")
          } else {
            event.preventDefault();
            setSubmitStatus('submitting');
            console.log('formData', formData);

            axios.post('https://us-central1-msquare-app.cloudfunctions.net/fb/flyzy/submit', formData)
              .then(response => {
                console.log('Submit success', response);
                setSubmitStatus('success');
              })
              .catch(error => {
                console.error('There was an error!', error.message);
                console.log(error);
                setSubmitStatus('error')
              });
          }
        }
      }
    }
  }


  const handleChange = event => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
      // value: event.target.value,
    });
  }
  const handlePhoneChange = phone => {
    setFormData({
      name: 'whatsapp',
      value: phone,
    });
  }
  const handleProfessionChange = prof => {
    console.log('Prof: ', prof);
    console.log('formDataBefore', formData);
    setFormData({
      name: 'profession',
      value: prof.value,
    });
    console.log('formDataAfter', formData);
  }
  const handleModifyOption = mod => {
    setFormData({
      name: 'modifyOptionSelected',
      value: mod.value,
    });
  }
  const handleDepAirportChange = airport => {
    setFormData({
      name: 'depAirport',
      value: airport.value,
    });
  }
  const handleArrAirportChange = airport => {
    setFormData({
      name: 'arrAirport',
      value: airport.value,
    });
  }
  const handleDepartureDate = date => {
    setFormData({
      name: 'departureDate',
      value: date,
    });
  }
  const handleReturnDate = date => {
    setFormData({
      name: 'returnDate',
      value: date,
    });
  }
  const handleFlexible = option => {
    setFormData({
      name: 'isFlexible',
      value: option.checked,
    });
  }
  const handleFirstNext = () => {
    setFormData({ name: 'page', value: 1 })
  }

  const handleNext = () => {
    console.log(formData.name + formData.depAirport + formData.arrAirport);
    if (!formData.name || !formData.depAirport || !formData.arrAirport) {
      alert('Please fill required fields')
    } else {
      setFormData({
        name: 'page',
        value: 2,
      });
      console.log('page', formData.page);

    }
  }

  const handleBack = date => {
    setFormData({
      name: 'page',
      value: formData.page - 1,
    });
    console.log('page', formData.page);
  }
  const handleHome = date => {
    setFormData(
      {
        name: 'page',
        value: 0,
      },
      {
        name: 'reset',
        value: true,
      });
    setSubmitStatus('pending');
    console.log('page', formData.page);

  }
  return (
    <div className="home">


      {formData.page === 0 &&
        <div className='page0'>
          <div className='header' >
            <img src={logosquare} alt="" className="logo" />
          </div>
          <div className="uniquetext">
            <div className="medium">Now Finding <span className='bold'>Cheapest</span> Flights are <span className="bold">EASY</span></div>
          </div>
          <div className="content">
            <div className="rich">
              <div className="left">
                <div className="text">
                  <div className="small">Save upto</div>
                  <div className="big"> 50%</div>
                </div>
                <div className="text-below">
                  <div className="small">On all domestic flights</div>
                </div>
                <button className="button" onClick={handleFirstNext}>NEXT</button>
              </div>
              <div className="right">
                <img className='img' src={phone} alt="" />
              </div>
            </div>
          </div>
        </div>}
      {
        formData.page === 1 &&
        <div className="page1">
          <div className='header' >
            <img src={logosquare} alt="" className="logo" />
          </div>
          <form >
            <div className="formInput">
              <div className='title'>NAME</div>

              <input name='name' type="name" className="input" value={formData.name} onChange={handleChange} placeholder='Full Name' />

            </div>
            <div className="formInput">
              <span className='title'>FROM</span>

              <Fragment>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  // defaultValue={airportOptions[0]}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={true}
                  name="depAirport"
                  options={airportOptions}
                  onChange={handleDepAirportChange}
                />

                <div
                  style={{
                    color: 'hsl(0, 0%, 40%)',
                    display: 'inline-block',
                    fontSize: 12,
                    fontStyle: 'italic',
                    marginTop: '1em',
                    Width: '400px'
                  }}
                >
                </div>
              </Fragment>

            </div>
            <div className="formInput">
              <div className='title'>TO</div>

              <Fragment>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  // defaultValue={airportOptions[0]}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={true}
                  name="arrAirport"
                  options={airportOptions}
                  onChange={handleArrAirportChange}
                />

                <div
                  style={{
                    color: 'hsl(0, 0%, 40%)',
                    display: 'inline-block',
                    fontSize: 12,
                    fontStyle: 'italic',
                    marginTop: '1em',
                    minWidth: '100%'
                  }}
                >
                </div>
              </Fragment>

            </div>
            <div className="centered">
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="journeyType"
                  value={formData.journeyType}
                  onChange={handleChange}
                >
                  <FormControlLabel value="2" control={<Radio />} label="Round Trip" />
                  <FormControlLabel value="1" control={<Radio />} label="One Way" />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="formInput">
              <div className='title'>DATE</div>

              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat={'dd/MM/yyyy'}
                  label="Custom input"
                  value={formData.departureDate}
                  onChange={(newValue) => {
                    console.log('ddt', newValue);
                    handleDepartureDate(newValue);
                  }}
                  renderInput={({ inputRef, inputProps, InputProps }) => (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <input className='input' ref={inputRef} {...inputProps} />
                      {InputProps?.endAdornment}
                    </Box>
                  )}
                />
              </LocalizationProvider>
            </div>
            {formData.journeyType === '2' &&
              <div className="formInput">
                <div className='title'>RETURN DATE</div>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Custom input"
                    inputFormat={'dd/MM/yyyy'}
                    value={formData.returnDate}
                    onChange={(newValue) => {
                      handleReturnDate(newValue);
                      console.log('rdt', newValue);
                    }}
                    renderInput={({ inputRef, inputProps, InputProps }) => (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <input className='input' ref={inputRef} {...inputProps} />
                        {InputProps?.endAdornment}
                      </Box>
                    )}
                  />
                </LocalizationProvider>
              </div>}
            <div className="centered">
              <FormControlLabel
                label="Dates Flexible?"
                control={<Checkbox
                  name='isFlexible'
                  //  size="small"
                  checked={formData.isFlexible}
                  onChange={handleChange}
                  inputProps={{ 'aria-label': 'controlled' }}
                />}
              />
            </div>
          </form>
          <div className='button-row'>
            <a className='button' onClick={handleBack}>Back</a>
            <a className='button-submit' onClick={handleNext}>Next</a>
          </div>

        </div >
      }
      {formData.page === 2 &&
        <div className="page2">
          <div className='header' >
            <img src={logosquare} alt="" className="logo" />
          </div>
          <div className="tagline">
            <div className="text">
              Your travel assitant will get back to you with<br></br><span><strong> BEST PRICES</strong></span> available across Platforms</div>
          </div>
          <div className="centered">
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="contactType"
                value={formData.contactType}
                onChange={handleChange}
              >
                <div>
                  <FormControlLabel value="whatsapp" control={<Radio />} label="WhatsApp" />
                  <FormControlLabel value="email" control={<Radio />} label="Email" />
                </div>

              </RadioGroup>
            </FormControl>
            <div className="formInput">

              {formData.contactType === 'whatsapp' && <PhoneInput
                // label='Whatsapp number'
                defaultCountry="IN"
                value={formData.whatsapp ?? ''}
                onChange={handlePhoneChange}
                inputComponent={CustomPhoneNumber} />}
              {/* {formData.contactType === 'whatsapp' && <input name='whatsapp' type="phone" className="input" value={formData.whatsapp} onChange={handleChange} placeholder='+91 1234567890' />} */}
              {formData.contactType === 'email' && <input name='email' type="email" className="input" value={formData.email} onChange={handleChange} placeholder='ram@example.com' />}
              <div className="formInput">
                <div className='space'></div>
                <div className='title'>PROFESSION</div>

                <Fragment>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    // defaultValue={airportOptions[0]}
                    isDisabled={false}
                    isLoading={false}
                    isClearable={true}
                    isRtl={false}
                    isSearchable={true}
                    name="profession"
                    options={professionOptions}
                    onChange={handleProfessionChange}
                  />
                  {(formData.profession === 'Other' || formData.profession === '') &&
                    <TextField id="profession" type='name' name="professionInput" onChange={handleChange} value={formData.professionInput || ''} label="Profession" variant="standard" size='medium' fullWidth />
                  }

                  <div
                    style={{
                      color: 'hsl(0, 0%, 40%)',
                      display: 'inline-block',
                      fontSize: 12,
                      fontStyle: 'italic',
                      marginTop: '1em',
                      minWidth: '100%'
                    }}
                  >
                  </div>
                </Fragment>

              </div>
            </div>
          </div>
          <div className="final-dialog">
            {submitStatus === 'pending' && <div className='button-row'>
              <a className='button' onClick={handleBack}>Back</a>
              <a className='button-submit' onClick={handleSubmit}>Submit</a>
            </div>}
            {submitStatus === 'submitting' &&
              <div className='loader'>Loading...</div>}
            {submitStatus === 'success' &&
              <>
                <div id='form-success' className='success'>Submitted :&#41;
                  <div className='button-row'>
                    <a className='button' onClick={handleHome}>Home</a>
                  </div>
                </div>
              </>}
            {submitStatus === 'error' &&
              <>
                <div className='error'>Something went wrong :&#40;
                  <div className='button-row'>
                    <a className='button' onClick={handleBack}>Back</a>
                    <a className='button-submit' onClick={handleSubmit}>Submit</a>
                  </div>
                </div>
              </>}

          </div>
          <div className="footer">
            <div className='img-left'>
              <img className='img-left' src={createdBy} alt="" />
            </div>
            <div className='img-right'>
              <img className='img-right' src={backedBy} alt="" />
            </div>

          </div>
        </div>

      }
    </div >
  )

}

export default App